export const allCoursesData = {
  // Software Courses
  "python": {
  title: "Python Programming",
  description:
    "Learn Python programming from basics to advanced concepts and build real-world applications",
  category: "Software",
  duration: "3 months",
  level: "Beginner to Intermediate",
  students: "520+",
  rating: 4.7,
  price: "₹18,000",
  whatIsCourse:
    "Python Programming is a beginner-friendly yet comprehensive course designed to teach you one of the most popular and versatile programming languages in the world. The course covers Python fundamentals, data structures, object-oriented programming, file handling, modules, and libraries. It also introduces advanced concepts like database connectivity, web development frameworks, and automation. With hands-on projects and practical exercises, learners gain the confidence to solve real-world problems and pursue careers in software development, data science, and automation.",
  image:
    "https://webandcrafts.com/_next/image?url=https%3A%2F%2Fadmin.wac.co%2Fuploads%2FFeatures_Of_Python_1_f4ccd6d9f7.jpg&w=4500&q=90",
  syllabus: [
    {
      module: "Module 1: Python Basics",
      topics: [
        "Introduction to Python & IDE setup",
        "Variables, Data Types & Operators",
        "Control Structures (if, loops)",
        "Functions & Modules",
        "Error Handling & Exceptions",
      ],
    },
    {
      module: "Module 2: Data Structures & OOP",
      topics: [
        "Lists, Tuples, Sets, Dictionaries",
        "String Manipulation",
        "File Handling",
        "Object-Oriented Programming (Classes, Objects, Inheritance)",
        "Working with Libraries",
      ],
    },
    {
      module: "Module 3: Advanced Python",
      topics: [
        "Regular Expressions",
        "Database Connectivity (SQLite/MySQL)",
        "Working with APIs",
        "Automation with Python",
        "Introduction to Data Analysis (NumPy, Pandas)",
      ],
    },
    {
      module: "Module 4: Projects & Applications",
      topics: [
        "Web Development with Flask/Django (Basics)",
        "Data Visualization (Matplotlib/Seaborn)",
        "Building REST APIs",
        "Mini Automation Scripts",
        "Capstone Project",
      ],
    },
  ],
  tools: [
    "Python",
    "PyCharm/VS Code",
    "Jupyter Notebook",
    "SQLite/MySQL",
    "Flask/Django",
    "Git",
  ],
  whatYouLearn: [
    "Write efficient Python programs",
    "Understand data structures and algorithms",
    "Work with databases using Python",
    "Automate repetitive tasks",
    "Develop simple web applications",
    "Perform basic data analysis and visualization",
    "Build real-world projects for your portfolio",
  ],
  whoCanEnroll: [
    "Beginners with no coding background",
    "Software development aspirants",
    "Data science and AI enthusiasts",
    "Automation engineers",
    "Web development beginners",
    "Computer science students",
  ],
  careerPaths: [
    "Python Developer",
    "Software Engineer",
    "Automation Engineer",
    "Data Analyst",
    "Web Developer (Flask/Django)",
    "Machine Learning Engineer (with further study)",
  ],
  testimonials: [
    {
      name: "Arun Mehta",
      role: "Python Developer at Infosys",
      content:
        "This course is well-structured and practical. The projects helped me master Python quickly and apply it at work.",
      rating: 5,
    },
    {
      name: "Sneha Kapoor",
      role: "Data Analyst Intern at Wipro",
      content:
        "Loved the data analysis and automation parts. The Python basics were taught in a very simple way for beginners.",
      rating: 4,
    },
  ],
},
  "dotnet-full-stack": {
    title: ".NET Full Stack Development",
    description:
      "Build enterprise applications using .NET Core backend with modern frontend frameworks",
    category: "Software",
    duration: "6 months",
    level: "Intermediate to Advanced",
    students: "290+",
    rating: 4.7,
    price: "₹30,000",
    image:
      "https://images.ctfassets.net/23aumh6u8s0i/7fPg2FUAcANY1i4sWj5XyM/a816b876c6a5ea96e8ad2596397efcc1/dotnet",
    whatIsCourse:
      ".NET Full Stack Development is a comprehensive program that teaches students to build enterprise-grade applications using Microsoft's .NET ecosystem. The course begins with web development fundamentals including HTML5, CSS3, and JavaScript, then progresses to C# programming, ASP.NET Core, and modern frontend frameworks like Angular or React. Students learn to create scalable, secure, and high-performance applications that can handle enterprise-level requirements. With Microsoft's strong enterprise presence and .NET's cross-platform capabilities, this course prepares students for high-paying positions in corporate environments.",
    syllabus: [
      {
        module: "Module 1: Web Development Fundamentals",
        topics: [
          "HTML5 - Advanced Elements, Forms, Semantic Web",
          "CSS3 - Advanced Styling, Grid, Flexbox, Animations",
          "JavaScript ES6+ - Modern Programming, Async/Await",
          "TypeScript Fundamentals",
          "Responsive Web Design Principles",
        ],
      },
      {
        module: "Module 2: C# Programming & .NET Fundamentals",
        topics: [
          "C# Programming Language Fundamentals",
          "Object-Oriented Programming in C#",
          ".NET Core Framework Architecture",
          "LINQ & Entity Framework Core",
          "Dependency Injection & Design Patterns",
        ],
      },
      {
        module: "Module 3: ASP.NET Core & Web API Development",
        topics: [
          "ASP.NET Core MVC Architecture",
          "Web API Development & RESTful Services",
          "Authentication & Authorization (Identity)",
          "Middleware & Custom Filters",
          "SignalR for Real-time Applications",
        ],
      },
      {
        module: "Module 4: Frontend Integration & Deployment",
        topics: [
          "Angular/React Integration with .NET",
          "SQL Server Database Design & Operations",
          "Testing with xUnit & Moq",
          "Azure Cloud Deployment",
          "DevOps & CI/CD with Azure DevOps",
        ],
      },
    ],
    advancedTopics: [
      "Microservices with .NET Core",
      "Azure Service Bus & Event Grid",
      "Docker Containerization",
      "Kubernetes Orchestration",
      "Azure Functions (Serverless)",
      "Advanced Security Patterns",
      "Performance Monitoring & APM",
      "Enterprise Integration Patterns",
    ],
    tools: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "TypeScript",
      "C#",
      ".NET Core",
      "ASP.NET Core",
      "Entity Framework",
      "SQL Server",
      "Azure",
      "Visual Studio",
      "Git",
      "Docker",
    ],
    whatYouLearn: [
      "Master web fundamentals with HTML5, CSS3, and JavaScript/TypeScript",
      "Build enterprise applications with C# and .NET Core",
      "Develop scalable Web APIs and microservices",
      "Implement robust security and authentication systems",
      "Work with SQL Server and Entity Framework Core",
      "Deploy applications to Microsoft Azure cloud",
      "Follow enterprise development patterns and practices",
      "Create high-performance, scalable applications",
    ],
    whoCanEnroll: [
      "C# developers wanting full-stack skills",
      "Enterprise application developers",
      "Microsoft technology enthusiasts",
      "Software engineers seeking corporate roles",
      "Developers interested in cloud technologies",
    ],
    careerPaths: [
      ".NET Full Stack Developer",
      "ASP.NET Core Developer",
      "Enterprise Application Developer",
      "Cloud Solutions Architect",
      "Senior Software Engineer",
      "Technical Lead",
    ],
    testimonials: [
      {
        name: "Rajesh Kumar",
        role: ".NET Developer at Microsoft",
        content:
          "Outstanding course covering the entire .NET ecosystem. The Azure integration modules were particularly valuable.",
        rating: 5,
      },
      {
        name: "Kavya Sharma",
        role: "Full Stack Developer at Accenture",
        content:
          "Comprehensive training with real-world projects. Perfect preparation for enterprise development roles.",
        rating: 5,
      },
    ],
  },

  "c programming": {
    title: "C Programming Fundamentals",
    description:
      "Master the foundation of programming with C language - the mother of all programming languages",
    category: "Software",
    duration: "3 months",
    level: "Beginner",
    students: "600+",
    rating: 4.5,
    price: "₹12,000",
    image:
      "https://i.pinimg.com/736x/51/16/39/511639ed8370cb83211f49e0d8f04af2.jpg",
    whatIsCourse:
      "C Programming is a foundational course that introduces students to the core principles of computer programming and software development. Known for its speed and efficiency, C is widely used in system programming, embedded systems, and operating systems. This course covers essential concepts such as data types, control structures, functions, arrays, pointers, and memory management. By mastering C, students build a strong programming base that enhances their problem-solving skills and prepares them for advanced languages like C++, Java, and Python, as well as low-level system development.",

    syllabus: [
      {
        module: "Module 1: Programming Basics",
        topics: [
          "Introduction to Programming",
          "C Language History & Features",
          "Setting up Development Environment",
          "Basic Syntax & Structure",
          "Variables & Data Types",
        ],
      },
      {
        module: "Module 2: Control Structures",
        topics: [
          "Operators & Expressions",
          "Conditional Statements",
          "Loops & Iterations",
          "Break & Continue",
          "Nested Structures",
        ],
      },
      {
        module: "Module 3: Functions & Arrays",
        topics: [
          "Function Definition & Declaration",
          "Parameter Passing",
          "Recursion",
          "Arrays & Strings",
          "Multi-dimensional Arrays",
        ],
      },
      {
        module: "Module 4: Advanced Concepts",
        topics: [
          "Pointers & Memory Management",
          "Structures & Unions",
          "File Handling",
          "Dynamic Memory Allocation",
          "Preprocessor Directives",
        ],
      },
    ],
    tools: [
      "Code::Blocks",
      "Dev-C++",
      "Visual Studio Code",
      "GCC Compiler",
      "Turbo C",
      "CLion",
    ],
    whatYouLearn: [
      "Understand programming fundamentals",
      "Write efficient C programs",
      "Master memory management concepts",
      "Implement data structures",
      "Debug and optimize code",
      "Prepare foundation for other languages",
      "Develop problem-solving skills",
    ],
    whoCanEnroll: [
      "Complete programming beginners",
      "Students starting computer science",
      "Anyone interested in programming",
      "Professionals switching to tech",
      "Engineering students",
    ],
    careerPaths: [
      "C Programmer",
      "System Programmer",
      "Embedded Systems Developer",
      "Software Developer",
      "Game Developer",
      "Firmware Engineer",
    ],
    testimonials: [
      {
        name: "Arjun Patel",
        role: "Software Engineer at Samsung",
        content:
          "Perfect starting point for programming. The concepts were explained clearly with practical examples.",
        rating: 5,
      },
      {
        name: "Pooja Sharma",
        role: "Embedded Developer at Bosch",
        content:
          "Excellent foundation course. The pointer concepts helped me a lot in my embedded systems career.",
        rating: 5,
      },
    ],
  },
  cpp: {
    title: "C++ Programming",
    description:
      "Master object-oriented programming with C++ and build powerful applications",
    category: "Software",
    duration: "4 months",
    level: "Beginner to Intermediate",
    students: "450+",
    rating: 4.6,
    price: "₹15,000",
    whatIsCourse:
      "C++ Programming is a powerful course designed to teach both procedural and object-oriented programming concepts. Building on the foundations of C, this course introduces advanced features such as classes, objects, inheritance, polymorphism, and templates. C++ is widely used in software development for system applications, game engines, real-time simulations, and high-performance applications. Students will gain hands-on experience in writing efficient and reusable code, developing a strong foundation in algorithmic thinking and software design that prepares them for complex programming challenges in modern software engineering.",

    image:
      "https://i.pinimg.com/736x/c6/65/d3/c665d32b9c684fc60719696b2fad88e7.jpg",
    syllabus: [
      {
        module: "Module 1: C++ Fundamentals",
        topics: [
          "C++ vs C Differences",
          "Object-Oriented Concepts",
          "Classes & Objects",
          "Constructors & Destructors",
          "Access Specifiers",
        ],
      },
      {
        module: "Module 2: OOP Principles",
        topics: [
          "Inheritance",
          "Polymorphism",
          "Encapsulation",
          "Abstraction",
          "Virtual Functions",
        ],
      },
      {
        module: "Module 3: Advanced Features",
        topics: [
          "Operator Overloading",
          "Templates",
          "Exception Handling",
          "File I/O Operations",
          "STL (Standard Template Library)",
        ],
      },
      {
        module: "Module 4: Modern C++",
        topics: [
          "Smart Pointers",
          "Lambda Expressions",
          "Move Semantics",
          "Multithreading",
          "Design Patterns",
        ],
      },
    ],
    tools: [
      "Visual Studio",
      "Code::Blocks",
      "CLion",
      "Qt Creator",
      "GCC",
      "Clang",
    ],
    whatYouLearn: [
      "Master object-oriented programming",
      "Build complex applications",
      "Understand memory management",
      "Implement design patterns",
      "Use STL effectively",
      "Write efficient and maintainable code",
      "Prepare for advanced programming roles",
    ],
    whoCanEnroll: [
      "C programmers looking to advance",
      "Computer science students",
      "Software development enthusiasts",
      "Game development aspirants",
      "System programming learners",
    ],
    careerPaths: [
      "C++ Developer",
      "Game Developer",
      "System Software Engineer",
      "Application Developer",
      "Software Architect",
      "Technical Lead",
    ],
    testimonials: [
      {
        name: "Vikram Singh",
        role: "Game Developer at Ubisoft",
        content:
          "Comprehensive C++ course with excellent coverage of OOP concepts. Perfect for game development preparation.",
        rating: 5,
      },
      {
        name: "Neha Agarwal",
        role: "Software Engineer at Microsoft",
        content:
          "The STL and modern C++ sections were particularly valuable. Great practical exercises throughout.",
        rating: 4,
      },
    ],
  },

  "java": {
    title: "Java Programming",
    description:
      "Comprehensive Java course covering core concepts to enterprise development",
    category: "Software",
    duration: "5 months",
    level: "Beginner to Advanced",
    students: "400+",
    rating: 4.7,
    price: "₹20,000",
    whatIsCourse:
      "Java Programming is a versatile and industry-standard course that introduces students to the fundamentals of object-oriented programming using Java. This course covers core concepts such as classes, objects, inheritance, polymorphism, exception handling, collections, multithreading, and file I/O. Java is platform-independent and widely used in enterprise applications, Android development, and backend systems. Through hands-on coding and real-world projects, students develop strong programming logic and are well-prepared for roles in software development, mobile app development, and enterprise application engineering.",

    image:
      "https://i.pinimg.com/736x/bd/89/3a/bd893a529d494acb0977cf90413987f1.jpg",
    syllabus: [
      {
        module: "Module 1: Java Fundamentals",
        topics: [
          "Introduction to Java",
          "Variables and Data Types",
          "Control Structures",
          "Arrays and Strings",
          "Methods and Functions",
        ],
      },
      {
        module: "Module 2: Object-Oriented Programming",
        topics: [
          "Classes and Objects",
          "Inheritance",
          "Polymorphism",
          "Encapsulation",
          "Abstraction",
        ],
      },
      {
        module: "Module 3: Advanced Java Concepts",
        topics: [
          "Exception Handling",
          "Collections Framework",
          "Multithreading",
          "File I/O",
          "Generics",
        ],
      },
      {
        module: "Module 4: Enterprise Java",
        topics: ["JDBC", "Servlets", "JSP", "Spring Framework", "Hibernate"],
      },
    ],
    tools: [
      "Java SE",
      "Eclipse IDE",
      "IntelliJ IDEA",
      "Maven",
      "Spring Boot",
      "Hibernate",
      "MySQL",
      "Tomcat",
      "Git",
      "JUnit",
    ],
    whatYouLearn: [
      "Master Java programming fundamentals",
      "Understand object-oriented programming concepts",
      "Build enterprise-level applications",
      "Work with databases using JDBC and Hibernate",
      "Develop web applications with Spring framework",
      "Write clean, maintainable code",
      "Debug and test Java applications",
    ],
    whoCanEnroll: [
      "Programming beginners",
      "Students pursuing computer science",
      "Professionals switching to Java",
      "Developers wanting to learn enterprise Java",
      "Anyone interested in software development",
    ],
    careerPaths: [
      "Java Developer",
      "Backend Developer",
      "Enterprise Application Developer",
      "Software Engineer",
      "Spring Developer",
      "Full Stack Java Developer",
    ],
    testimonials: [
      {
        name: "Amit Patel",
        role: "Java Developer at InfoSys",
        content:
          "The Java course was well-structured and covered everything from basics to advanced concepts. Great for beginners and experienced developers alike.",
        rating: 5,
      },
      {
        name: "Sneha Reddy",
        role: "Software Engineer at Wipro",
        content:
          "Excellent hands-on approach with real projects. The instructors were very knowledgeable and supportive throughout the course.",
        rating: 4,
      },
    ],
  },

  "asp-net": {
    title: "ASP.NET Development",
    description:
      "Build powerful web applications using Microsoft's ASP.NET framework",
    category: "Software",
    duration: "4 months",
    level: "Intermediate",
    students: "320+",
    rating: 4.5,
    price: "₹22,000",
    whatIsCourse:
      "ASP.NET is a comprehensive web development course focused on building dynamic, scalable, and secure web applications using Microsoft's .NET framework. This course covers essential concepts such as web forms, MVC architecture, Razor pages, server-side scripting, state management, and database integration with SQL Server. Students learn to create responsive and data-driven web applications using C# and Visual Studio. With real-world projects and hands-on practice, learners gain the skills required to develop enterprise-level web applications and are well-prepared for careers in full-stack and backend .NET development.",

    image:
      "https://i.pinimg.com/736x/9e/bd/cc/9ebdcc8215bbf83c420b157a231aead0.jpg",
    syllabus: [
      {
        module: "Module 1: .NET Fundamentals",
        topics: [
          "Introduction to .NET Framework",
          "C# Programming Basics",
          "Object-Oriented Programming in C#",
          "Visual Studio IDE",
          ".NET Core vs .NET Framework",
        ],
      },
      {
        module: "Module 2: ASP.NET Web Forms",
        topics: [
          "Web Forms Architecture",
          "Server Controls",
          "State Management",
          "Master Pages",
          "User Controls",
        ],
      },
      {
        module: "Module 3: ASP.NET MVC",
        topics: [
          "MVC Architecture Pattern",
          "Controllers & Actions",
          "Views & Razor Syntax",
          "Models & Data Binding",
          "Routing & Filters",
        ],
      },
      {
        module: "Module 4: Advanced Topics",
        topics: [
          "Entity Framework",
          "Web API Development",
          "Authentication & Authorization",
          "Deployment & Hosting",
          "Performance Optimization",
        ],
      },
    ],
    tools: [
      "Visual Studio",
      "SQL Server",
      "Entity Framework",
      "IIS",
      "Azure",
      "Git",
      "NuGet",
    ],
    whatYouLearn: [
      "Build dynamic web applications",
      "Master C# programming language",
      "Understand MVC architecture",
      "Work with databases using Entity Framework",
      "Create RESTful web APIs",
      "Implement security features",
      "Deploy applications to cloud",
    ],
    whoCanEnroll: [
      "Web developers",
      "C# programming enthusiasts",
      "Microsoft technology learners",
      "Enterprise application developers",
      "Computer science graduates",
    ],
    careerPaths: [
      ".NET Developer",
      "ASP.NET Developer",
      "Full Stack .NET Developer",
      "Web Application Developer",
      "Software Engineer",
      "Technical Architect",
    ],
    testimonials: [
      {
        name: "Rajesh Kumar",
        role: ".NET Developer at TCS",
        content:
          "Comprehensive ASP.NET course with excellent practical examples. The MVC section was particularly well-explained.",
        rating: 5,
      },
      {
        name: "Priyanka Joshi",
        role: "Software Engineer at Cognizant",
        content:
          "Great course for understanding Microsoft technologies. The Entity Framework module was very helpful.",
        rating: 4,
      },
    ],
  },
  "html": {
  "title": "HTML Web Development",
  "description":
    "Learn HTML from scratch and build structured, responsive, and interactive web pages with real-world projects.",
  "category": "Software",
  "duration": "3 months",
  "level": "Beginner",
  "students": "610+",
  "rating": 4.6,
  "price": "₹12,000",
  "whatIsCourse":
    "HTML Web Development is a beginner-friendly course designed to teach the fundamentals of web page structure and design using HTML. The course covers HTML tags, attributes, forms, multimedia, tables, semantic elements, and responsive layouts. Learners also gain exposure to CSS basics for styling and JavaScript integration for interactivity. By the end of the course, you will be able to create fully functional websites and projects from scratch.",
  "image":
    "https://nestify.io/wp-content/uploads/2024/01/What-is-HTML.jpg",
  "syllabus": [
    {
      "module": "Module 1: HTML Basics",
      "topics": [
        "Introduction to Web & HTML",
        "HTML Structure & Syntax",
        "Headings, Paragraphs, Links",
        "Lists (Ordered & Unordered)",
        "Images & Multimedia Embedding"
      ]
    },
    {
      "module": "Module 2: Page Structure & Forms",
      "topics": [
        "Tables & Layouts",
        "Forms & Input Elements",
        "Attributes & Validation",
        "Semantic HTML (header, nav, section, article, footer)",
        "Accessibility & SEO Basics"
      ]
    },
    {
      "module": "Module 3: Advanced HTML & Styling",
      "topics": [
        "HTML5 Elements & APIs",
        "Audio & Video Integration",
        "Canvas & SVG Basics",
        "Introduction to CSS for Styling",
        "Embedding JavaScript for Interactivity"
      ]
    },
    {
      "module": "Module 4: Projects & Applications",
      "topics": [
        "Building a Personal Portfolio Website",
        "Creating Interactive Forms",
        "Responsive Layout with HTML & CSS",
        "Simple Blog Page Project",
        "Capstone Project: Multi-Page Website"
      ]
    }
  ],
  "tools": [
    "HTML5",
    "VS Code / Sublime Text",
    "Web Browsers (Chrome/Firefox)",
    "Git & GitHub",
    "CSS & JavaScript (for integration)"
  ],
  "whatYouLearn": [
    "Build and structure websites using HTML",
    "Work with multimedia, tables, and forms",
    "Use semantic HTML for accessibility and SEO",
    "Apply CSS for styling and JavaScript for interactivity",
    "Develop responsive and user-friendly web pages",
    "Create real-world projects like portfolio and blogs"
  ],
  "whoCanEnroll": [
    "Beginners with no prior coding knowledge",
    "Students interested in web development",
    "Designers who want to learn website structure",
    "Freelancers planning to build personal websites",
    "Aspiring front-end developers"
  ],
  "careerPaths": [
    "Front-End Web Developer",
    "UI Developer",
    "Web Designer",
    "Junior Web Developer",
    "Freelance Web Developer"
  ],
  "testimonials": [
    {
      "name": "Rahul Sharma",
      "role": "Front-End Intern",
      "content":
        "This HTML course gave me the foundation I needed to start web development. The projects were very practical.",
      "rating": 5
    },
    {
      "name": "Neha Singh",
      "role": "Freelance Web Designer",
      "content":
        "I was new to coding, but the explanations were simple and easy to follow. Now I can build websites on my own.",
      "rating": 4
    }
  ]
},
"linux": {
  "title": "Linux: Open-Source Operating System & System Administration",
  "description": "Master the fundamentals of Linux, from installation and command-line usage to system administration and server deployment.",
  "category": "Software",
  "duration": "4 months",
  "level": "Beginner to Intermediate",
  "students": "1,800+",
  "rating": 4.8,
  "price": "₹32,000",
  "whatIsCourse": "This course is designed for aspiring system administrators, developers, and tech enthusiasts who want to understand and work with Linux-based systems. Covering everything from basic shell commands and file systems to user management, networking, and security, learners will gain hands-on experience with popular distributions like Ubuntu, Fedora, and Debian. By the end of the course, students will be able to confidently navigate Linux environments, automate tasks with shell scripting, and manage servers for web hosting, cloud deployment, and enterprise infrastructure.",
  "image": "https://www.zentyal.com/wp-content/uploads/2024/02/Linux-operating-system.png",
  "syllabus": [
    {
      "module": "Module 1: Introduction to Linux",
      "topics": [
        "What is Linux and its history",
        "Linux vs Unix vs Windows",
        "Popular distributions (Ubuntu, Fedora, Debian)",
        "Installing Linux on virtual machines",
        "Basic terminal commands"
      ]
    },
    {
      "module": "Module 2: File System & Shell Scripting",
      "topics": [
        "Linux file system hierarchy",
        "Permissions and ownership",
        "Navigating directories and managing files",
        "Shell scripting basics",
        "Automating tasks with cron jobs"
      ]
    },
    {
      "module": "Module 3: System Administration",
      "topics": [
        "User and group management",
        "Package management (APT, YUM)",
        "Process monitoring and control",
        "Disk partitioning and LVM",
        "System logging and troubleshooting"
      ]
    },
    {
      "module": "Module 4: Networking & Security",
      "topics": [
        "Network configuration and tools",
        "Firewall setup and SELinux/AppArmor",
        "SSH and remote access",
        "Server setup (Apache, NGINX)",
        "Linux hardening and best practices"
      ]
    }
  ],
  "tools": [
    "Ubuntu",
    "Fedora",
    "Debian",
    "Bash Shell",
    "VirtualBox",
    "Docker"
  ],
  "whatYouLearn": [
    "Install and configure Linux systems",
    "Use shell commands and scripting for automation",
    "Manage users, files, and processes",
    "Set up and secure Linux servers",
    "Troubleshoot system and network issues",
    "Deploy applications using Linux environments"
  ],
  "whoCanEnroll": [
    "Aspiring system administrators",
    "Software developers",
    "IT support professionals",
    "Cloud engineers",
    "Cybersecurity learners",
    "Tech enthusiasts"
  ],
  "careerPaths": [
    "Linux System Administrator",
    "DevOps Engineer",
    "Cloud Infrastructure Specialist",
    "Network Administrator",
    "Security Analyst",
    "Technical Support Engineer"
  ],
  "testimonials": [
    {
      "name": "Sandeep R.",
      "role": "DevOps Engineer",
      "content": "This course gave me the confidence to manage Linux servers and automate deployments. The shell scripting module was especially powerful.",
      "rating": 5
    },
    {
      "name": "Megha Tiwari",
      "role": "IT Support Specialist",
      "content": "I started with zero Linux experience and now I troubleshoot systems and manage users daily. Highly recommended!",
      "rating": 4.5
    }
  ]
},
"sql": {
  "title": "SQL: Structured Query Language & Database Management",
  "description": "Master SQL to manage, query, and analyze data in relational databases for web, business, and enterprise applications.",
  "category": "Software",
  "duration": "3.5 months",
  "level": "Beginner to Intermediate",
  "students": "2,200+",
  "rating": 4.8,
  "price": "₹27,000",
  "whatIsCourse": "The SQL course is designed for aspiring developers, analysts, and IT professionals who want to learn how to interact with relational databases. Covering everything from basic queries to advanced joins, indexing, and stored procedures, this course provides hands-on experience with popular database systems like MySQL, PostgreSQL, and Microsoft SQL Server. Learners will gain the skills to create, manipulate, and retrieve data efficiently, enabling them to build data-driven applications, generate reports, and support business intelligence workflows.",
  "image": "https://media.istockphoto.com/id/1800292591/photo/sql-structured-query-language-technology-concept-icon-virtual-screen.jpg?s=612x612&w=0&k=20&c=Natt2t_aFsr-KlPiMMQUPKIX6sbDb2hOTRhUFcSq6cA=",
  "syllabus": [
    {
      "module": "Module 1: Introduction to SQL & Databases",
      "topics": [
        "What is SQL and RDBMS",
        "Installing MySQL/PostgreSQL",
        "Database design and normalization",
        "Creating tables and schemas",
        "Basic SELECT queries"
      ]
    },
    {
      "module": "Module 2: Data Manipulation & Filtering",
      "topics": [
        "INSERT, UPDATE, DELETE operations",
        "WHERE clause and logical operators",
        "Sorting and limiting results",
        "Aggregate functions (SUM, COUNT, AVG)",
        "GROUP BY and HAVING"
      ]
    },
    {
      "module": "Module 3: Advanced Querying",
      "topics": [
        "JOINs (INNER, LEFT, RIGHT, FULL)",
        "Subqueries and nested SELECTs",
        "Views and temporary tables",
        "Stored procedures and functions",
        "Error handling and transactions"
      ]
    },
    {
      "module": "Module 4: Performance & Integration",
      "topics": [
        "Indexing and query optimization",
        "User roles and permissions",
        "Connecting SQL with web apps (PHP, Python)",
        "Exporting data to CSV/JSON",
        "Final project: Build a mini database app"
      ]
    }
  ],
  "tools": [
    "MySQL",
    "PostgreSQL",
    "Microsoft SQL Server",
    "SQLite",
    "phpMyAdmin",
    "DBeaver"
  ],
  "whatYouLearn": [
    "Write efficient SQL queries",
    "Design and manage relational databases",
    "Perform data analysis and reporting",
    "Use joins and subqueries for complex logic",
    "Create stored procedures and views",
    "Optimize performance with indexing",
    "Integrate SQL with web and business apps"
  ],
  "whoCanEnroll": [
    "Web developers",
    "Data analysts",
    "Software engineers",
    "Business intelligence professionals",
    "Students in computer science",
    "IT support and database admins"
  ],
  "careerPaths": [
    "Database Developer",
    "SQL Analyst",
    "Data Engineer",
    "Business Intelligence Specialist",
    "Backend Developer",
    "System Administrator"
  ],
  "testimonials": [
    {
      "name": "Kavita Rao",
      "role": "Data Analyst",
      "content": "This course helped me master SQL from scratch. I now write complex queries and generate reports for my team with confidence.",
      "rating": 5
    },
    {
      "name": "Manoj Pillai",
      "role": "Backend Developer",
      "content": "The JOINs and stored procedures modules were incredibly useful. I use these skills daily in my web projects.",
      "rating": 4.5
    }
  ]
},
"vbscript": {
  "title": "VBScript: Legacy Scripting for Windows Automation",
  "description": "Learn VBScript to automate tasks, build interactive web components, and manage Windows environments using classic scripting techniques.",
  "category": "Software",
  "duration": "2.5 months",
  "level": "Beginner to Intermediate",
  "students": "700+",
  "rating": 4.4,
  "price": "₹16,000",
  "whatIsCourse": "This course introduces VBScript (Visual Basic Scripting Edition), a lightweight scripting language developed by Microsoft for automating tasks in Windows environments and enhancing web interactivity. Students will learn how to write scripts for Windows Script Host (WSH), Internet Explorer, and legacy ASP applications. The course covers syntax, control structures, functions, and integration with COM objects. Though VBScript is deprecated in modern browsers, it remains valuable for legacy systems, enterprise automation, and understanding scripting fundamentals.",
  "image": "https://i0.wp.com/olresourcecenter.uplandsoftware.com/wp-content/uploads/2024/09/VB.png?fit=1024%2C768&ssl=1",
  "syllabus": [
    {
      "module": "Module 1: VBScript Basics",
      "topics": [
        "Introduction to VBScript and its history",
        "Setting up the scripting environment",
        "Variables, data types, and operators",
        "Control flow: If, Select Case, Loops",
        "Writing and executing basic scripts"
      ]
    },
    {
      "module": "Module 2: Functions & Error Handling",
      "topics": [
        "Creating and calling functions",
        "Built-in VBScript functions",
        "Input/output with MsgBox and InputBox",
        "Error handling with On Error Resume Next",
        "Debugging techniques"
      ]
    },
    {
      "module": "Module 3: Windows Automation",
      "topics": [
        "Using Windows Script Host (WSH)",
        "File system operations with FileSystemObject",
        "Registry access and environment variables",
        "Automating tasks with scripts",
        "Scheduling scripts with Task Scheduler"
      ]
    },
    {
      "module": "Module 4: Web & Legacy Integration",
      "topics": [
        "Embedding VBScript in HTML",
        "Client-side scripting in Internet Explorer",
        "Server-side scripting in classic ASP",
        "Interacting with COM objects",
        "Final project: Windows automation script"
      ]
    }
  ],
  "tools": [
    "Windows Script Host (WSH)",
    "Internet Explorer",
    "Notepad++ / Visual Studio Code",
    "Task Scheduler",
    "Classic ASP (optional)"
  ],
  "whatYouLearn": [
    "Write and execute VBScript code",
    "Automate Windows tasks and file operations",
    "Use control structures and functions effectively",
    "Integrate VBScript with HTML and legacy web apps",
    "Access system resources via COM and WSH",
    "Debug and troubleshoot scripts"
  ],
  "whoCanEnroll": [
    "System administrators",
    "IT support professionals",
    "Web developers maintaining legacy systems",
    "QA testers using automation tools",
    "Students exploring scripting fundamentals",
    "Tech hobbyists interested in retro scripting"
  ],
  "careerPaths": [
    "Windows Automation Specialist",
    "Legacy Web Developer",
    "QA Automation Engineer",
    "IT Support Technician",
    "Scripting Consultant",
    "System Integration Analyst"
  ],
  "testimonials": [
    {
      "name": "Deepak Nair",
      "role": "System Administrator",
      "content": "This course helped me automate repetitive tasks across our Windows network. VBScript still has its place in enterprise environments.",
      "rating": 5
    },
    {
      "name": "Sneha R.",
      "role": "QA Analyst",
      "content": "I used VBScript in QTP years ago, and this course refreshed my skills. Great for understanding scripting logic and automation.",
      "rating": 4.5
    }
  ]
},
"basic_computer": {
  "title": "Basic Computer Course",
  "description":
    "Start your computer journey with this beginner-friendly course covering fundamentals, MS Office, internet usage, and essential digital skills.",
  "category": "Software",
  "duration": "3 months",
  "level": "Beginner",
  "students": "1,050+",
  "rating": 4.5,
  "price": "₹8,000",
  "whatIsCourse":
    "The Basic Computer Course is designed for beginners who want to gain essential computer skills for daily life, office work, and career readiness. The course covers computer fundamentals, operating systems, MS Office tools, internet and email usage, and basic troubleshooting. With practical exercises, learners gain confidence in using computers effectively at home, in education, and in the workplace.",
  "image":
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMsyGMlhHLvcO6CQfiOUG5i3dITiD-TUImew&s",
  "syllabus": [
    {
      "module": "Module 1: Computer Fundamentals",
      "topics": [
        "Introduction to Computers & Operating Systems",
        "Understanding Hardware & Software",
        "File Management (Create, Save, Organize)",
        "Basic Troubleshooting"
      ]
    },
    {
      "module": "Module 2: MS Office Applications",
      "topics": [
        "MS Word – Creating & Formatting Documents",
        "MS Excel – Basic Formulas & Tables",
        "MS PowerPoint – Simple Presentations",
        "MS Paint – Drawing & Designing Basics"
      ]
    },
    {
      "module": "Module 3: Internet & Email",
      "topics": [
        "Using Web Browsers (Google Chrome, Edge)",
        "Searching Information Online",
        "Creating & Using Email Accounts",
        "Online Forms & Applications"
      ]
    },
    {
      "module": "Module 4: Practical Applications",
      "topics": [
        "Using Pen Drives & External Devices",
        "Digital Transactions (UPI, Online Banking Basics)",
        "Cyber Safety & Awareness",
        "Mini Project – Creating Office Documents"
      ]
    }
  ],
  "tools": [
    "Windows OS",
    "MS Office Suite",
    "MS Paint",
    "Web Browsers",
    "Email Services (Gmail/Outlook)"
  ],
  "whatYouLearn": [
    "Operate a computer with confidence",
    "Work with MS Word, Excel, and PowerPoint",
    "Use the internet and email for communication",
    "Apply digital literacy in daily tasks",
    "Understand cyber safety and basic troubleshooting",
    "Create simple projects like reports and presentations"
  ],
  "whoCanEnroll": [
    "Absolute beginners to computers",
    "Students preparing for higher studies",
    "Office staff needing computer literacy",
    "Homemakers learning digital skills",
    "Senior citizens who want to use computers"
  ],
  "careerPaths": [
    "Computer Operator",
    "Office Assistant",
    "Data Entry Clerk",
    "Front Office Executive",
    "Personal Secretary (with further training)"
  ],
  "testimonials": [
    {
      "name": "Sunita Devi",
      "role": "Homemaker",
      "content":
        "This course helped me learn MS Office and online payments. Now I use computers confidently at home.",
      "rating": 5
    },
    {
      "name": "Ramesh Yadav",
      "role": "Office Clerk",
      "content":
        "I had no prior computer knowledge, but the basics were taught very clearly. It improved my office productivity.",
      "rating": 4
    }
  ]
},
"foxpro": {
  "title": "FoxPro Programming",
  "description":
    "Learn FoxPro programming and database management to build business applications and strengthen your procedural programming skills.",
  "category": "Software",
  "duration": "3 months",
  "level": "Beginner to Intermediate",
  "students": "290+",
  "rating": 4.4,
  "price": "₹15,000",
  "whatIsCourse":
    "FoxPro Programming is designed to introduce learners to one of the classic database management and programming tools. The course covers FoxPro commands, database operations, forms, reports, and procedural programming concepts. Students will also learn to create business applications like inventory systems, billing software, and reporting solutions. Though FoxPro is a legacy technology, it provides a strong foundation for database programming and structured coding practices.",
  "image":
    "https://mir-s3-cdn-cf.behance.net/projects/404/75488330199437.5617a40ab2e2a.png",
  "syllabus": [
    {
      "module": "Module 1: Introduction to FoxPro",
      "topics": [
        "Overview of FoxPro Environment",
        "Data Types & Commands",
        "Creating & Managing Databases",
        "Working with Tables & Records"
      ]
    },
    {
      "module": "Module 2: Programming with FoxPro",
      "topics": [
        "Variables & Operators",
        "Control Structures (IF, Loops)",
        "Procedures & Functions",
        "Error Handling"
      ]
    },
    {
      "module": "Module 3: Forms, Reports & Applications",
      "topics": [
        "Designing Forms & Menus",
        "Creating Reports",
        "File Handling & Indexing",
        "Developing Business Applications"
      ]
    },
    {
      "module": "Module 4: Advanced Features",
      "topics": [
        "Relational Databases in FoxPro",
        "Using SQL Commands in FoxPro",
        "Importing & Exporting Data",
        "Mini Project – Business Database Application"
      ]
    }
  ],
  "tools": [
    "FoxPro IDE",
    "FoxPro Database Engine",
    "SQL (within FoxPro)",
    "Report Designer"
  ],
  "whatYouLearn": [
    "Work with FoxPro environment and commands",
    "Design and manage databases with tables and relations",
    "Use control structures and functions in FoxPro",
    "Create business applications with forms and reports",
    "Apply SQL commands inside FoxPro",
    "Develop mini-projects like billing or inventory systems"
  ],
  "whoCanEnroll": [
    "Beginners in programming and database management",
    "Students of commerce and business IT",
    "Office professionals handling database records",
    "Learners interested in legacy software systems",
    "Entry-level programmers"
  ],
  "careerPaths": [
    "Database Assistant",
    "FoxPro Programmer (Legacy Systems)",
    "Office IT Support",
    "Business Application Developer",
    "Data Entry & Reporting Executive"
  ],
  "testimonials": [
    {
      "name": "Ravi Kumar",
      "role": "Database Assistant",
      "content":
        "The FoxPro course helped me understand databases and programming logic. I could build a simple inventory system by myself.",
      "rating": 5
    },
    {
      "name": "Meena Gupta",
      "role": "Office Executive",
      "content":
        "I learned how to manage office records and generate reports easily with FoxPro. Very practical and useful.",
      "rating": 4
    }
  ]
},





  //Hardware courses
  "a+n+": {
    title: "CompTIA A+ & Network+",
    description:
      "Master essential IT skills and networking fundamentals with CompTIA A+ and Network+ certifications",
    category: "Hardware",
    duration: "5 months",
    level: "Beginner to Intermediate",
    students: "500+",
    rating: 4.6,
    price: "₹28,000",
    whatIsCourse:
      "The CompTIA A+ and Network+ course is a foundational IT training program designed for individuals aspiring to start or advance their careers in IT support and networking. The A+ portion covers computer hardware, software, troubleshooting, operating systems, and security essentials. The Network+ portion focuses on networking concepts, protocols, IP addressing, routing, switching, network troubleshooting, and security. Learners gain practical knowledge to set up, configure, and manage IT systems, preparing them for globally recognized certifications. With real-world labs and case studies, this course builds job-ready skills in IT support, technical troubleshooting, and networking administration.",
    image:
      "https://nctaindia.in/images/course/n.png",
    syllabus: [
      {
        module: "Module 1: CompTIA A+ Core 1 (220-1101)",
        topics: [
          "Hardware components and devices",
          "Mobile devices and peripherals",
          "Networking basics",
          "Hardware troubleshooting",
          "Virtualization and cloud computing",
        ],
      },
      {
        module: "Module 2: CompTIA A+ Core 2 (220-1102)",
        topics: [
          "Operating system installation and configuration",
          "Windows, macOS, Linux basics",
          "Security best practices",
          "Software troubleshooting",
          "Operational procedures",
        ],
      },
      {
        module: "Module 3: Networking Fundamentals",
        topics: [
          "OSI & TCP/IP models",
          "IP addressing and subnetting",
          "Routing & Switching basics",
          "Wireless networking",
          "Network devices and cabling",
        ],
      },
      {
        module: "Module 4: Network+ Advanced Concepts",
        topics: [
          "Network services and protocols (DHCP, DNS, VPN)",
          "Network security principles",
          "Troubleshooting methodologies",
          "Performance optimization",
          "Network design and implementation",
        ],
      },
    ],
    tools: [
      "Packet Tracer",
      "Wireshark",
      "VirtualBox/VMware",
      "Windows & Linux OS",
      "CompTIA CertMaster Labs",
      "Cisco Networking Devices",
    ],
    whatYouLearn: [
      "Understand PC hardware and operating systems",
      "Install and configure devices and networks",
      "Troubleshoot hardware, software, and network issues",
      "Apply security best practices",
      "Subnetting and IP addressing",
      "Work with routers, switches, and firewalls",
      "Prepare for CompTIA A+ and Network+ certification exams",
    ],
    whoCanEnroll: [
      "IT beginners",
      "Aspiring IT support specialists",
      "Helpdesk technicians",
      "Networking enthusiasts",
      "Computer science students",
      "Professionals seeking CompTIA certification",
    ],
    careerPaths: [
      "IT Support Specialist",
      "Help Desk Technician",
      "Network Support Technician",
      "System Administrator",
      "Technical Support Engineer",
      "Network Administrator",
    ],
    testimonials: [
      {
        name: "Ankit Sharma",
        role: "IT Support Engineer at Infosys",
        content:
          "This course gave me the confidence to clear my CompTIA A+ certification. The labs and troubleshooting scenarios were very practical.",
        rating: 5,
      },
      {
        name: "Sneha Reddy",
        role: "Network Technician at Wipro",
        content:
          "Network+ section was excellent! Subnetting and routing were taught in a very simple way. Highly recommend this combo course.",
        rating: 4,
      },
    ],
  },
  "ccna": {
    title: "CCNA (Cisco Certified Network Associate)",
    description:
      "Gain the skills to configure, manage, and troubleshoot enterprise networks with Cisco's industry-recognized CCNA certification",
    category: "Hardware",
    duration: "4.5 months",
    level: "Intermediate",
    students: "450+",
    rating: 4.7,
    price: "₹30,000",
    whatIsCourse:
      "The CCNA course is a globally recognized certification program designed to build a solid foundation in networking. It covers key concepts such as network fundamentals, IP addressing, routing and switching, security fundamentals, and automation. Students will learn to configure Cisco routers and switches, troubleshoot common networking issues, and implement secure and scalable network solutions. With practical labs, simulations, and real-world scenarios, learners gain the confidence to work in enterprise networking environments and are well-prepared to pass the Cisco CCNA certification exam.",
    image:
      "https://www.webhopers.in/uploads/1/ccna-training-online.jpg",
    syllabus: [
      {
        module: "Module 1: Networking Fundamentals",
        topics: [
          "OSI & TCP/IP Models",
          "IPv4 and IPv6 Addressing",
          "Subnetting and VLSM",
          "Network Topologies",
          "Cabling and Network Devices",
        ],
      },
      {
        module: "Module 2: Routing and Switching",
        topics: [
          "Cisco IOS Basics",
          "Static and Dynamic Routing (RIP, OSPF, EIGRP)",
          "VLANs and Inter-VLAN Routing",
          "Spanning Tree Protocol (STP)",
          "Switching Concepts & Troubleshooting",
        ],
      },
      {
        module: "Module 3: Network Services and Security",
        topics: [
          "DHCP and DNS",
          "NAT and PAT",
          "Access Control Lists (ACLs)",
          "Wireless LANs",
          "Security Fundamentals (Firewalls, VPNs)",
        ],
      },
      {
        module: "Module 4: Automation and Exam Prep",
        topics: [
          "Network Automation Basics",
          "Cisco Packet Tracer & GNS3 Labs",
          "WAN Technologies",
          "Troubleshooting Methodologies",
          "Exam Preparation & Mock Tests",
        ],
      },
    ],
    tools: [
      "Cisco Packet Tracer",
      "GNS3",
      "Cisco Routers & Switches",
      "Wireshark",
      "Cisco IOS",
      "Virtual Labs",
    ],
    whatYouLearn: [
      "Understand networking concepts and protocols",
      "Master IPv4/IPv6 addressing and subnetting",
      "Configure and troubleshoot routers and switches",
      "Implement VLANs, STP, and routing protocols",
      "Secure networks with ACLs, VPNs, and firewalls",
      "Work with Cisco IOS and network automation",
      "Prepare for Cisco CCNA certification exam",
    ],
    whoCanEnroll: [
      "Networking beginners with basic IT knowledge",
      "IT support professionals",
      "Aspiring network administrators",
      "System administrators",
      "Computer science and engineering students",
      "Professionals seeking Cisco certification",
    ],
    careerPaths: [
      "Network Engineer",
      "Network Administrator",
      "Systems Engineer",
      "IT Support Specialist",
      "Infrastructure Engineer",
      "Network Security Engineer",
    ],
    testimonials: [
      {
        name: "Rohit Verma",
        role: "Network Engineer at HCL",
        content:
          "The hands-on labs were amazing! This course made routing and switching very clear and helped me crack the CCNA exam on the first attempt.",
        rating: 5,
      },
      {
        name: "Megha Kapoor",
        role: "System Administrator at Tech Mahindra",
        content:
          "Subnetting and OSPF lessons were taught in a very practical way. The Packet Tracer exercises were extremely useful.",
        rating: 4,
      },
    ],
  },
  "ccnp": {
    title: "CCNP (Cisco Certified Network Professional)",
    description:
      "Advance your networking career with professional-level Cisco certification in enterprise routing, switching, and troubleshooting",
    category: "Hardware",
    duration: "6 months",
    level: "Advanced",
    students: "250+",
    rating: 4.8,
    price: "₹45,000",
    whatIsCourse:
      "The CCNP course is designed for networking professionals aiming to deepen their expertise in enterprise-level networking. It covers advanced routing, switching, network troubleshooting, security, and automation concepts using Cisco technologies. Learners will work with Cisco routers, switches, and virtual labs to configure and manage complex networks. The course also prepares students for the CCNP Enterprise certification exams (ENCOR and ENARSI), equipping them with job-ready skills to design, implement, and troubleshoot scalable enterprise networks.",
    image:
      "https://www.iiht-ultadanga.in/wp-content/uploads/2021/12/CCNP.jpg",
    syllabus: [
      {
        module: "Module 1: Core Networking Concepts (ENCOR 350-401)",
        topics: [
          "Dual-stack (IPv4 & IPv6) architecture",
          "Routing protocols: OSPF, EIGRP, BGP",
          "Switching concepts and STP enhancements",
          "Virtualization and overlays",
          "Network automation and programmability",
        ],
      },
      {
        module: "Module 2: Advanced Routing (ENARSI 300-410)",
        topics: [
          "Advanced OSPF features",
          "EIGRP optimization",
          "BGP route selection and filtering",
          "Route redistribution and policy-based routing",
          "VPN technologies (DMVPN, MPLS, GRE)",
        ],
      },
      {
        module: "Module 3: Network Security and Services",
        topics: [
          "Access Control Lists (ACLs) & prefix lists",
          "DHCP, DNS, and NAT services",
          "IPsec VPN fundamentals",
          "Device security hardening",
          "QoS concepts for traffic management",
        ],
      },
      {
        module: "Module 4: Troubleshooting and Exam Preparation",
        topics: [
          "Cisco Troubleshooting Methodologies",
          "Troubleshooting routing and switching",
          "High availability and redundancy",
          "Hands-on labs with Packet Tracer & GNS3",
          "Mock exams and real-world scenarios",
        ],
      },
    ],
    tools: [
      "Cisco Packet Tracer",
      "GNS3",
      "Cisco VIRL/EVENG",
      "Cisco IOS",
      "Wireshark",
      "Virtual Labs with Routers & Switches",
    ],
    whatYouLearn: [
      "Design and manage enterprise-level networks",
      "Master advanced routing protocols (OSPF, EIGRP, BGP)",
      "Implement VPNs and secure network solutions",
      "Configure and troubleshoot Cisco routers and switches",
      "Understand QoS and traffic management",
      "Apply network automation and programmability",
      "Prepare for Cisco CCNP Enterprise certification exams",
    ],
    whoCanEnroll: [
      "CCNA-certified professionals",
      "Network engineers seeking career growth",
      "System administrators moving into networking",
      "IT professionals aiming for Cisco certifications",
      "Networking enthusiasts with intermediate knowledge",
    ],
    careerPaths: [
      "Senior Network Engineer",
      "Network Consultant",
      "Infrastructure Architect",
      "Systems Engineer",
      "Network Security Specialist",
      "IT Infrastructure Manager",
    ],
    testimonials: [
      {
        name: "Arjun Mehta",
        role: "Senior Network Engineer at Cisco",
        content:
          "The labs were highly practical and closely aligned with the CCNP exam. BGP and VPN sections were particularly strong.",
        rating: 5,
      },
      {
        name: "Kavya Nair",
        role: "Network Consultant at Accenture",
        content:
          "This course helped me move from CCNA-level knowledge to handling enterprise-grade networks. The troubleshooting practice was very realistic.",
        rating: 4,
      },
    ],
  },
  "redhat-linux": {
    title: "Red Hat Linux (RHCSA & RHCE Certification)",
    description:
      "Master Linux system administration and enterprise-level server management with Red Hat certifications",
    category: "Hardware",
    duration: "5 months",
    level: "Intermediate to Advanced",
    students: "300+",
    rating: 4.7,
    price: "₹35,000",
    whatIsCourse:
      "The Red Hat Linux course is designed for IT professionals who want to develop expertise in Linux system administration and enterprise server management. Covering both RHCSA (Red Hat Certified System Administrator) and RHCE (Red Hat Certified Engineer) exam objectives, the course includes Linux installation, file systems, user and group management, networking, security, shell scripting, automation, and troubleshooting. Learners gain hands-on experience with Red Hat Enterprise Linux (RHEL), preparing them for globally recognized certifications and real-world roles in IT infrastructure management.",
    image:
      "https://www.smeclabs.net/wp-content/uploads/2024/02/redhat.png",
    syllabus: [
      {
        module: "Module 1: Linux Fundamentals (RHCSA)",
        topics: [
          "Introduction to Linux & RHEL",
          "File system hierarchy and permissions",
          "User and group management",
          "Package management with YUM/DNF",
          "System initialization and services",
        ],
      },
      {
        module: "Module 2: System Administration (RHCSA)",
        topics: [
          "Process management",
          "Storage management (LVM, partitions, RAID)",
          "Networking configuration",
          "Firewall and SELinux",
          "Basic shell scripting",
        ],
      },
      {
        module: "Module 3: Advanced Linux (RHCE)",
        topics: [
          "Automation with Ansible",
          "Network services (HTTP, DNS, FTP, SSH)",
          "System logging and monitoring",
          "Advanced storage concepts",
          "Performance tuning and optimization",
        ],
      },
      {
        module: "Module 4: Troubleshooting and Exam Preparation",
        topics: [
          "Backup and recovery strategies",
          "Common Linux troubleshooting scenarios",
          "High availability and clustering basics",
          "Hands-on practice labs",
          "Exam-oriented mock tests",
        ],
      },
    ],
    tools: [
      "Red Hat Enterprise Linux (RHEL)",
      "VirtualBox / VMware",
      "Ansible",
      "Bash Shell",
      "FirewallD & SELinux",
      "Linux Networking Tools",
    ],
    whatYouLearn: [
      "Install, configure, and manage Red Hat Enterprise Linux",
      "Work with users, groups, and file systems",
      "Configure and secure networking services",
      "Automate tasks using Ansible and shell scripts",
      "Implement storage solutions with LVM and RAID",
      "Apply security measures with SELinux and firewalls",
      "Prepare for RHCSA and RHCE certification exams",
    ],
    whoCanEnroll: [
      "System administrators",
      "IT professionals seeking Linux skills",
      "Networking professionals",
      "Students pursuing IT infrastructure careers",
      "DevOps and cloud engineers",
      "Aspirants for RHCSA/RHCE certification",
    ],
    careerPaths: [
      "Linux System Administrator",
      "Red Hat Certified Engineer",
      "DevOps Engineer",
      "Cloud Infrastructure Engineer",
      "IT Support Specialist",
      "Systems Architect",
    ],
    testimonials: [
      {
        name: "Sandeep Rao",
        role: "Linux System Administrator at IBM",
        content:
          "The Red Hat course was very practical with real-world labs. It helped me pass RHCSA on the first try.",
        rating: 5,
      },
      {
        name: "Neha Sharma",
        role: "DevOps Engineer at Capgemini",
        content:
          "The Ansible automation section was a game-changer. This course made me confident in Linux system administration.",
        rating: 4,
      },
    ],
  },
  "microsoft-server": {
    title: "Microsoft Windows Server Administration",
    description:
      "Learn to deploy, configure, and manage enterprise IT infrastructure with Microsoft Windows Server",
    category: "Hardware",
    duration: "5 months",
    level: "Intermediate",
    students: "280+",
    rating: 4.7,
    price: "₹38,000",
    whatIsCourse:
      "The Microsoft Windows Server course is designed for IT professionals who want to develop skills in managing and maintaining enterprise-level Windows Server environments. Covering topics from installation and configuration to Active Directory, Group Policy, networking, virtualization, and security, this course prepares learners for roles in system administration and infrastructure management. With real-world labs and case studies, students gain hands-on expertise in Windows Server administration and are prepared for certifications like MCSA and MCSE.",
    image:
      "https://media.istockphoto.com/id/1475998284/photo/interior-of-big-modern-server-room-3d-rendering-illustration.jpg?s=612x612&w=0&k=20&c=SwiGrf3JOjMdXTPfn1WEFekKq6B8WwEXIWVJkGixUck=",
    syllabus: [
      {
        module: "Module 1: Windows Server Fundamentals",
        topics: [
          "Introduction to Windows Server editions",
          "Server installation and configuration",
          "Windows Admin Center and PowerShell basics",
          "Roles and features in Windows Server",
          "Server Core vs Desktop Experience",
        ],
      },
      {
        module: "Module 2: Active Directory and Identity Management",
        topics: [
          "Active Directory Domain Services (AD DS)",
          "Users, groups, and organizational units",
          "Group Policy Objects (GPOs)",
          "Authentication and authorization",
          "FSMO roles and replication",
        ],
      },
      {
        module: "Module 3: Networking and Storage",
        topics: [
          "DHCP, DNS, and IP addressing",
          "File and Storage Services",
          "Distributed File System (DFS)",
          "Print and document services",
          "Windows Server networking features",
        ],
      },
      {
        module: "Module 4: Virtualization, Security & Troubleshooting",
        topics: [
          "Hyper-V and virtualization management",
          "Windows Server Update Services (WSUS)",
          "Backup and disaster recovery",
          "Security features and hardening",
          "Troubleshooting and monitoring tools",
        ],
      },
    ],
    tools: [
      "Windows Server 2019/2022",
      "Active Directory",
      "Group Policy Management Console",
      "PowerShell",
      "Hyper-V",
      "Windows Admin Center",
    ],
    whatYouLearn: [
      "Install and configure Microsoft Windows Server",
      "Manage Active Directory and Group Policy",
      "Configure and secure network services (DNS, DHCP)",
      "Set up and manage Hyper-V virtualization",
      "Implement backup and disaster recovery solutions",
      "Apply server security best practices",
      "Prepare for Microsoft MCSA/MCSE certification",
    ],
    whoCanEnroll: [
      "System administrators",
      "IT support specialists",
      "Networking professionals",
      "Microsoft technology learners",
      "Computer science students",
      "Aspirants for MCSA/MCSE certification",
    ],
    careerPaths: [
      "Windows System Administrator",
      "Infrastructure Engineer",
      "IT Support Engineer",
      "Systems Architect",
      "Cloud & Server Administrator",
      "Microsoft Certified Solutions Expert",
    ],
    testimonials: [
      {
        name: "Vikram Patel",
        role: "System Administrator at Wipro",
        content:
          "The Active Directory module was extremely useful. This course gave me hands-on knowledge I could apply directly at work.",
        rating: 5,
      },
      {
        name: "Pooja Menon",
        role: "Infrastructure Engineer at Infosys",
        content:
          "Great coverage of Windows Server basics to advanced topics. The Hyper-V labs were very practical and exam-focused.",
        rating: 4,
      },
    ],
  },
"dtp": {
  "title": "Desktop Publishing (DTP)",
  "description":
    "Master the art of designing and publishing with DTP tools like CorelDraw, Photoshop, and InDesign/PageMaker. Create professional layouts, graphics, and print-ready materials.",
  "category": "Hardware",
  "duration": "4 months",
  "level": "Beginner to Intermediate",
  "students": "430+",
  "rating": 4.6,
  "price": "₹20,000",
  "whatIsCourse":
    "The Desktop Publishing (DTP) course is designed for learners who want to build careers in graphic design, publishing, and printing industries. It covers image editing, vector graphics, layout design, and professional publishing. With hands-on projects in CorelDraw, Photoshop, and InDesign/PageMaker, learners will be able to design brochures, magazines, advertisements, and other creative assets. The course is ideal for students, aspiring designers, and professionals in media and printing.",
  "image":
    "https://static.vecteezy.com/system/resources/previews/026/824/275/non_2x/dtp-logo-design-inspiration-for-a-unique-identity-modern-elegance-and-creative-design-watermark-your-success-with-the-striking-this-logo-vector.jpg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to DTP",
      "topics": [
        "Basics of Desktop Publishing",
        "Understanding Printing & Publishing Concepts",
        "Fonts, Colors & Typography",
        "Introduction to Graphic Design Principles"
      ]
    },
    {
      "module": "Module 2: CorelDraw – Vector Graphics",
      "topics": [
        "Drawing & Editing Shapes",
        "Working with Text & Fonts",
        "Logos, Brochures & Posters",
        "Creating Vector Illustrations"
      ]
    },
    {
      "module": "Module 3: Photoshop – Image Editing",
      "topics": [
        "Photo Retouching & Enhancement",
        "Working with Layers & Filters",
        "Banner & Advertisement Design",
        "Digital Image Compositions"
      ]
    },
    {
      "module": "Module 4: InDesign/PageMaker – Layout Design",
      "topics": [
        "Creating Page Layouts",
        "Designing Magazines & Newsletters",
        "Working with Master Pages & Templates",
        "Print-Ready Document Preparation"
      ]
    },
    {
      "module": "Module 5: Projects & Applications",
      "topics": [
        "Designing a Company Logo & Branding Kit",
        "Creating a Business Brochure",
        "Magazine/Book Layout Project",
        "Capstone Project – Professional DTP Portfolio"
      ]
    }
  ],
  "tools": [
    "CorelDraw",
    "Adobe Photoshop",
    "Adobe InDesign / PageMaker",
    "Fonts & Typography Libraries",
    "Printing Tools"
  ],
  "whatYouLearn": [
    "Work with CorelDraw for vector graphics",
    "Edit and retouch images using Photoshop",
    "Design page layouts using InDesign/PageMaker",
    "Create brochures, posters, and advertisements",
    "Prepare print-ready professional files",
    "Build a creative portfolio for publishing jobs"
  ],
  "whoCanEnroll": [
    "Students interested in graphic design",
    "Aspiring DTP operators",
    "Media and printing professionals",
    "Freelancers offering design services",
    "Entrepreneurs managing branding needs"
  ],
  "careerPaths": [
    "DTP Operator",
    "Graphic Designer",
    "Layout Designer",
    "Print Media Assistant",
    "Freelance Designer"
  ],
  "testimonials": [
    {
      "name": "Pooja Rani",
      "role": "Graphic Designer",
      "content":
        "The DTP course gave me confidence to design brochures and posters professionally. Now I work with clients as a freelancer.",
      "rating": 5
    },
    {
      "name": "Vikram Joshi",
      "role": "DTP Operator",
      "content":
        "CorelDraw and Photoshop training was very practical. I easily got a job in a printing press after completing this course.",
      "rating": 4
    }
  ]
},




  // Multimedia Courses
  "2d": {
  title: "2D Video Editing",
  description:
    "Learn professional video editing techniques to create stunning 2D content for films, ads, and social media",
  category: "Multimedia",
  duration: "3.5 months",
  level: "Beginner to Intermediate",
  students: "600+",
  rating: 4.6,
  price: "₹25,000",
  whatIsCourse:
    "The 2D Video Editing course is designed for aspiring editors and multimedia enthusiasts who want to master the art of storytelling through video. This course covers the fundamentals of video editing, including timeline management, transitions, color correction, audio synchronization, motion graphics, and export techniques. Students will gain hands-on experience with industry-standard tools like Adobe Premiere Pro and After Effects, learning how to edit videos for films, advertisements, YouTube, and social media. By the end of the course, learners will be capable of producing professional-quality 2D video projects and ready to pursue a career in video editing or digital media production.",
  image:
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBDdkgAap1cafjUrUGQa_pxU5HcQWFxyXb9Q&s",
  syllabus: [
    {
      module: "Module 1: Introduction to Video Editing",
      topics: [
        "Basics of video editing",
        "Understanding timelines and sequences",
        "Importing and organizing media",
        "Essential editing tools",
        "Cutting, trimming, and transitions",
      ],
    },
    {
      module: "Module 2: Audio & Visual Enhancement",
      topics: [
        "Audio editing and synchronization",
        "Adding background music and sound effects",
        "Color correction and grading",
        "Titles and lower thirds",
        "Working with 2D motion graphics",
      ],
    },
    {
      module: "Module 3: Advanced Editing Techniques",
      topics: [
        "Multi-camera editing",
        "Green screen & chroma key",
        "Keyframing and animations",
        "Dynamic transitions and effects",
        "Editing for ads and social media",
      ],
    },
    {
      module: "Module 4: Project Work & Final Output",
      topics: [
        "Project planning and storytelling",
        "Editing short films and commercials",
        "Export settings and formats",
        "Video compression for web and broadcast",
        "Portfolio building with real-world projects",
      ],
    },
  ],
  tools: [
    "Adobe Premiere Pro",
    "Adobe After Effects",
    "Final Cut Pro",
    "DaVinci Resolve",
    "Audition",
    "Media Encoder",
  ],
  whatYouLearn: [
    "Master the basics of video editing",
    "Enhance videos with color grading and sound",
    "Create 2D motion graphics and titles",
    "Edit for films, ads, YouTube, and social media",
    "Work with multi-camera projects and green screens",
    "Export videos in professional formats",
    "Build a strong portfolio with real-world projects",
  ],
  whoCanEnroll: [
    "Aspiring video editors",
    "Content creators and YouTubers",
    "Advertising and media students",
    "Freelancers in creative fields",
    "Graphic designers wanting to expand skills",
    "Film and animation enthusiasts",
  ],
  careerPaths: [
    "Video Editor",
    "Multimedia Specialist",
    "Motion Graphics Designer",
    "Content Creator",
    "Film & Advertising Editor",
    "Post-Production Artist",
  ],
  testimonials: [
    {
      name: "Rahul Sen",
      role: "Freelance Video Editor",
      content:
        "This course gave me the confidence to edit professional videos. The motion graphics module was a huge plus.",
      rating: 5,
    },
    {
      name: "Aditi Sharma",
      role: "YouTube Content Creator",
      content:
        "Perfect for beginners like me! I learned editing basics quickly and now edit my own videos with ease.",
      rating: 4,
    },
  ],
},
"3d": {
  title: "3D Video Editing",
  description:
    "Learn advanced 3D video editing and visual effects techniques to create cinematic and immersive content",
  category: "Multimedia",
  duration: "4.5 months",
  level: "Intermediate to Advanced",
  students: "420+",
  rating: 4.7,
  price: "₹32,000",
  whatIsCourse:
    "The 3D Video Editing course is tailored for learners who want to move beyond 2D editing and dive into the world of immersive visual storytelling. The course covers professional editing workflows, 3D visual effects (VFX), motion tracking, compositing, and rendering. Students will learn to combine live-action footage with 3D elements, use green screen techniques, create animations, and produce cinematic-quality content. With hands-on projects using tools like Adobe After Effects, Blender, and Autodesk Maya, learners will be able to craft 3D video projects for films, advertisements, gaming, and virtual content.",
  image:
    "https://flyuptechnology.com/wp-content/uploads/2022/12/depositphotos_12069970-stock-illustration-3d-word-symbol.webp",
  syllabus: [
    {
      module: "Module 1: 3D Video Editing Fundamentals",
      topics: [
        "Introduction to 3D video editing",
        "Editing workflows and timeline basics",
        "Green screen and chroma keying",
        "Importing 3D models and assets",
        "Understanding rendering and frame rates",
      ],
    },
    {
      module: "Module 2: Motion Graphics & Compositing",
      topics: [
        "3D text and motion graphics",
        "Camera tracking and stabilization",
        "Layer-based compositing",
        "Working with lighting and shadows",
        "Blending 2D and 3D elements",
      ],
    },
    {
      module: "Module 3: Visual Effects & Animation",
      topics: [
        "Particle effects and dynamics",
        "3D animation basics",
        "Rigging and character motion",
        "Special effects for films and gaming",
        "Advanced keyframing techniques",
      ],
    },
    {
      module: "Module 4: Final Project & Industry Workflow",
      topics: [
        "Editing cinematic trailers and ads",
        "Exporting 3D video for web and broadcast",
        "VR and AR video preparation",
        "Optimizing render times",
        "Portfolio-building with real-world projects",
      ],
    },
  ],
  tools: [
    "Adobe After Effects",
    "Blender",
    "Autodesk Maya",
    "Cinema 4D",
    "DaVinci Resolve",
    "Adobe Premiere Pro",
  ],
  whatYouLearn: [
    "Edit and enhance 3D video projects",
    "Work with motion graphics and compositing",
    "Use 3D models and animations in videos",
    "Apply VFX techniques for cinematic content",
    "Integrate live-action footage with 3D elements",
    "Prepare 3D video for films, ads, VR, and gaming",
    "Build a professional-level portfolio",
  ],
  whoCanEnroll: [
    "Aspiring video editors",
    "3D artists and animators",
    "Film and media students",
    "Gaming and VFX enthusiasts",
    "Content creators seeking advanced editing skills",
    "Professionals in advertising and film production",
  ],
  careerPaths: [
    "3D Video Editor",
    "VFX Artist",
    "Motion Graphics Designer",
    "Multimedia Specialist",
    "Film & Gaming Post-Production Artist",
    "3D Animation Specialist",
  ],
  testimonials: [
    {
      name: "Karan Malhotra",
      role: "VFX Artist at Prime Focus",
      content:
        "This course gave me a strong foundation in 3D editing and compositing. The Blender and After Effects combination was very practical.",
      rating: 5,
    },
    {
      name: "Sneha Gupta",
      role: "Freelance 3D Video Editor",
      content:
        "Excellent for learning both editing and visual effects. I loved working on cinematic trailers as final projects.",
      rating: 4,
    },
  ],
},
"audio": {
  title: "Audio Editing",
  description:
    "Master professional audio editing, mixing, and sound design techniques for music, films, and digital media",
  category: "Multimedia",
  duration: "3 months",
  level: "Beginner to Intermediate",
  students: "550+",
  rating: 4.6,
  price: "₹20,000",
  whatIsCourse:
    "The Audio Editing course is designed for learners who want to build skills in sound design, music editing, voiceover production, and audio post-processing. Covering essentials like noise reduction, equalization, compression, mixing, mastering, and synchronization, this course prepares students to work with audio for podcasts, films, advertisements, and music production. With hands-on training using industry-standard tools like Adobe Audition, Audacity, and Pro Tools, learners gain practical experience to produce professional-quality sound for multimedia projects.",
  image:
    "https://lwks.com/hubfs/Audio%20Editing%20Basics.webp",
  syllabus: [
    {
      module: "Module 1: Introduction to Audio Editing",
      topics: [
        "Basics of sound and waveforms",
        "Audio formats and bitrates",
        "Recording techniques and setup",
        "Editing basics: cutting, trimming, and fades",
        "Organizing and managing audio tracks",
      ],
    },
    {
      module: "Module 2: Audio Enhancement & Effects",
      topics: [
        "Noise reduction and audio cleanup",
        "Equalization (EQ) techniques",
        "Compression, reverb, and delay",
        "Voice enhancement and pitch correction",
        "Layering sound effects and music",
      ],
    },
    {
      module: "Module 3: Mixing & Mastering",
      topics: [
        "Multi-track mixing",
        "Balancing levels and panning",
        "Adding dynamics and filters",
        "Mastering for different platforms",
        "Audio synchronization with video",
      ],
    },
    {
      module: "Module 4: Project Work & Final Output",
      topics: [
        "Podcast editing and mastering",
        "Sound design for films and ads",
        "Music editing and remixing",
        "Exporting audio in multiple formats",
        "Portfolio projects with real-world scenarios",
      ],
    },
  ],
  tools: [
    "Adobe Audition",
    "Audacity",
    "Avid Pro Tools",
    "FL Studio",
    "Logic Pro X",
    "Steinberg Cubase",
  ],
  whatYouLearn: [
    "Edit, clean, and enhance audio tracks",
    "Apply EQ, compression, and audio effects",
    "Mix and master music, podcasts, and voiceovers",
    "Design sound for films, ads, and digital media",
    "Synchronize audio with video projects",
    "Export audio for multiple platforms",
    "Build a professional audio editing portfolio",
  ],
  whoCanEnroll: [
    "Aspiring audio editors",
    "Podcasters and content creators",
    "Musicians and music producers",
    "Film and media students",
    "YouTubers and voiceover artists",
    "Freelancers in sound design",
  ],
  careerPaths: [
    "Audio Editor",
    "Sound Designer",
    "Music Producer",
    "Podcast Editor",
    "Post-Production Engineer",
    "Voiceover Editor",
  ],
  testimonials: [
    {
      name: "Aman Khurana",
      role: "Freelance Sound Designer",
      content:
        "The course was very practical and helped me clean and mix audio professionally. The EQ and mastering lessons were top-notch.",
      rating: 5,
    },
    {
      name: "Ritika Sharma",
      role: "Podcast Producer",
      content:
        "Perfect for beginners! I learned how to edit podcasts, remove noise, and enhance voice quality quickly.",
      rating: 4,
    },
  ],
},
"visual-effects": {
  title: "Visual Effects (VFX)",
  description:
    "Learn the art of creating stunning visual effects for films, ads, games, and digital media using industry-standard tools",
  category: "Multimedia",
  duration: "6 months",
  level: "Intermediate to Advanced",
  students: "370+",
  rating: 4.8,
  price: "₹40,000",
  whatIsCourse:
    "The Visual Effects (VFX) course is designed for aspiring artists and professionals who want to bring imagination to life on screen. Covering compositing, motion tracking, 3D integration, green screen, particle systems, and CGI techniques, the course blends creativity with technical expertise. Students will work with tools like Adobe After Effects, Nuke, Blender, and Maya to create realistic effects for films, advertisements, gaming, and OTT platforms. By the end of the course, learners will be equipped with the skills to pursue careers in VFX studios, animation companies, and the film industry.",
  image:
    "https://images.pexels.com/photos/1229841/pexels-photo-1229841.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  syllabus: [
    {
      module: "Module 1: VFX Fundamentals",
      topics: [
        "Introduction to VFX and industry workflows",
        "Basics of compositing and layer management",
        "Green screen & chroma key techniques",
        "Rotoscoping and masking",
        "Match moving and motion tracking",
      ],
    },
    {
      module: "Module 2: 2D & 3D Compositing",
      topics: [
        "Working with 2D & 3D layers",
        "Camera tracking and stabilization",
        "Integrating CGI with live footage",
        "Lighting and shadow effects",
        "Advanced keying techniques",
      ],
    },
    {
      module: "Module 3: Visual Effects Creation",
      topics: [
        "Particle systems (fire, smoke, rain, explosions)",
        "Wire removal and clean-up",
        "Dynamic simulations",
        "Matte painting and environment creation",
        "Animating visual effects",
      ],
    },
    {
      module: "Module 4: Advanced VFX & Project Work",
      topics: [
        "Compositing for films and advertisements",
        "VFX for gaming and OTT platforms",
        "Rendering and optimization",
        "Industry workflows and pipelines",
        "Portfolio projects and demo reels",
      ],
    },
  ],
  tools: [
    "Adobe After Effects",
    "Foundry Nuke",
    "Autodesk Maya",
    "Blender",
    "Cinema 4D",
    "Mocha Pro",
  ],
  whatYouLearn: [
    "Understand VFX pipelines and workflows",
    "Perform rotoscoping, tracking, and keying",
    "Integrate 3D elements into live-action footage",
    "Create particle effects and dynamic simulations",
    "Work with advanced compositing techniques",
    "Design visual effects for films, ads, and games",
    "Build a professional VFX showreel",
  ],
  whoCanEnroll: [
    "Aspiring VFX artists",
    "Film and animation students",
    "Graphic designers and video editors",
    "Gaming enthusiasts",
    "YouTubers and content creators",
    "Professionals seeking careers in film post-production",
  ],
  careerPaths: [
    "VFX Artist",
    "Compositor",
    "Motion Graphics Designer",
    "3D & CGI Artist",
    "Film & Gaming Post-Production Specialist",
    "Multimedia FX Designer",
  ],
  testimonials: [
    {
      name: "Deepak Yadav",
      role: "Compositor at Red Chillies VFX",
      content:
        "This course gave me real industry-ready skills. The compositing and particle effects lessons were excellent.",
      rating: 5,
    },
    {
      name: "Shruti Nair",
      role: "VFX Intern at MPC",
      content:
        "Very practical and hands-on! I built a strong showreel that helped me land my first VFX internship.",
      rating: 4,
    },
  ],
},
"3da": {
  "title": "3D Animation",
  "description":
    "Learn 3D animation from scratch, including modeling, texturing, lighting, rigging, and animation using industry-standard tools. Build a professional demo reel for careers in animation, film, and gaming.",
  "category": "Multimedia",
  "duration": "6 months",
  "level": "Beginner to Advanced",
  "students": "280+",
  "rating": 4.8,
  "price": "₹60,000",
  "whatIsCourse":
    "The 3D Animation course is designed to help learners master the art of creating animated 3D content for films, games, advertisements, and digital media. The course covers 3D modeling, texturing, lighting, rigging, character animation, and rendering. Students will work with tools like Autodesk Maya, Blender, and After Effects to create professional-quality animations. By the end of the course, learners will develop a demo reel showcasing their skills, preparing them for careers in animation, VFX, or gaming industries.",
  "image":
    "https://www.image.edu.in/images/course-img/specialized-programme-in-3d-animation-course/why-img.jpg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to 3D Animation",
      "topics": [
        "History & Basics of Animation",
        "Principles of Animation",
        "Overview of 3D Animation Pipeline",
        "Introduction to 3D Software (Maya/Blender)"
      ]
    },
    {
      "module": "Module 2: Modeling & Texturing",
      "topics": [
        "Polygon & NURBS Modeling",
        "3D Environment & Character Modeling",
        "UV Mapping & Texturing",
        "Shaders & Materials"
      ]
    },
    {
      "module": "Module 3: Lighting & Rendering",
      "topics": [
        "Lighting Techniques in 3D",
        "Cameras & Perspectives",
        "Rendering Engines (Arnold/Blender Cycles)",
        "Compositing Basics"
      ]
    },
    {
      "module": "Module 4: Rigging & Animation",
      "topics": [
        "Character Rigging & Skinning",
        "Animating Characters & Objects",
        "Walk Cycles & Lip Sync",
        "Physics & Dynamics (Hair, Cloth, Particles)"
      ]
    },
    {
      "module": "Module 5: Visual Effects & Post-Production",
      "topics": [
        "Adding VFX in Animation",
        "Compositing with After Effects",
        "Green Screen & Motion Graphics",
        "Sound Synchronization"
      ]
    },
    {
      "module": "Module 6: Portfolio & Projects",
      "topics": [
        "Short Animation Project",
        "Game Asset Design",
        "3D Product Visualization",
        "Capstone Project – Demo Reel"
      ]
    }
  ],
  "tools": [
    "Autodesk Maya",
    "Blender",
    "3ds Max",
    "Substance Painter",
    "Adobe Photoshop",
    "Adobe After Effects",
    "Arnold Renderer"
  ],
  "whatYouLearn": [
    "Create 3D models, textures, and environments",
    "Animate characters, objects, and scenes",
    "Work with lighting, rendering, and VFX",
    "Develop realistic simulations with physics & dynamics",
    "Edit and composite animations for final output",
    "Build a professional demo reel for animation careers"
  ],
  "whoCanEnroll": [
    "Students aspiring to work in animation & VFX",
    "Creative professionals interested in 3D design",
    "Gamers and aspiring game designers",
    "Artists transitioning to digital media",
    "Anyone passionate about animation and storytelling"
  ],
  "careerPaths": [
    "3D Animator",
    "Character Designer",
    "Game Artist",
    "VFX Artist",
    "Lighting & Rendering Artist",
    "Multimedia Specialist"
  ],
  "testimonials": [
    {
      "name": "Karan Patel",
      "role": "3D Animator at Gaming Studio",
      "content":
        "This course gave me the skills to start a career in gaming. The rigging and animation modules were very practical.",
      "rating": 5
    },
    {
      "name": "Shweta Rao",
      "role": "Freelance VFX Artist",
      "content":
        "I built my first demo reel here and landed freelance projects. The software training was industry-standard.",
      "rating": 4
    }
  ]
},
"adobe": {
  "title": "Adobe Mastery: Creative Suite Essentials",
  "description": "Master the most powerful tools in Adobe Creative Cloud to create stunning visuals, videos, and digital experiences.",
  "category": "Multimedia",
  "duration": "4 months",
  "level": "Beginner to Advanced",
  "students": "1,200+",
  "rating": 4.8,
  "price": "₹35,000",
  "whatIsCourse": "The Adobe Mastery course is designed for creatives, professionals, and enthusiasts who want to unlock the full potential of Adobe Creative Cloud. Covering Photoshop, Illustrator, Premiere Pro, After Effects, InDesign, and Adobe Express, this course teaches everything from photo editing and vector illustration to video production and layout design. Learners will gain hands-on experience with real-world projects, building a portfolio that showcases their skills across multiple media formats. Whether you're aiming to become a graphic designer, video editor, or digital content creator, this course equips you with the tools and techniques to thrive in the creative industry.",
  "image": "https://images.unsplash.com/photo-1649734926700-8dfb770ffaee?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YWRvYmV8ZW58MHx8MHx8fDA%3D",
  "syllabus": [
    {
      "module": "Module 1: Adobe Photoshop & Illustrator",
      "topics": [
        "Photo editing and retouching",
        "Layer management and masking",
        "Vector illustration and pen tool mastery",
        "Typography and branding assets",
        "Exporting for web and print"
      ]
    },
    {
      "module": "Module 2: Adobe Premiere Pro & After Effects",
      "topics": [
        "Video editing fundamentals",
        "Transitions and effects",
        "Motion graphics and keyframing",
        "Green screen and compositing",
        "Audio editing and synchronization"
      ]
    },
    {
      "module": "Module 3: Adobe InDesign & Express",
      "topics": [
        "Layout design for print and digital",
        "Creating brochures, magazines, and eBooks",
        "Social media content creation",
        "Templates and quick design workflows",
        "Publishing and sharing projects"
      ]
    },
    {
      "module": "Module 4: Portfolio & Certification",
      "topics": [
        "Capstone project across Adobe tools",
        "Creative storytelling and branding",
        "Preparing files for clients and agencies",
        "Certification exam prep",
        "Building a professional portfolio"
      ]
    }
  ],
  "tools": [
    "Adobe Photoshop",
    "Adobe Illustrator",
    "Adobe Premiere Pro",
    "Adobe After Effects",
    "Adobe InDesign",
    "Adobe Express"
  ],
  "whatYouLearn": [
    "Edit and enhance photos like a pro",
    "Design logos, icons, and vector graphics",
    "Create cinematic videos and animations",
    "Design layouts for print and digital media",
    "Build social media content with Adobe Express",
    "Master cross-platform workflows",
    "Develop a creative portfolio for career growth"
  ],
  "whoCanEnroll": [
    "Graphic designers",
    "Video editors and filmmakers",
    "Marketing professionals",
    "Content creators and influencers",
    "Students in design and media",
    "Freelancers and entrepreneurs"
  ],
  "careerPaths": [
    "Graphic Designer",
    "Video Editor",
    "Motion Graphics Artist",
    "Digital Content Creator",
    "Brand Designer",
    "Creative Director"
  ],
  "testimonials": [
    {
      "name": "Sneha Verma",
      "role": "Brand Designer",
      "content": "This course helped me master Adobe tools and land freelance gigs. The portfolio module was a game-changer.",
      "rating": 5
    },
    {
      "name": "Karan Mehta",
      "role": "YouTube Filmmaker",
      "content": "I never thought I could edit videos and design thumbnails all in one course. Adobe Mastery made it possible.",
      "rating": 4.5
    }
  ]
},
"adobephoto": {
  "title": "Adobe Photoshop: Digital Imaging & Design",
  "description": "Master the world’s leading image editing software to create stunning visuals, graphics, and photo compositions.",
  "category": "Multimedia",
  "duration": "3 months",
  "level": "Beginner to Intermediate",
  "students": "1,500+",
  "rating": 4.7,
  "price": "₹28,000",
  "whatIsCourse": "The Adobe Photoshop course is designed for aspiring designers, photographers, and digital artists who want to learn professional image editing and graphic design. This course covers essential tools and techniques including layers, masks, retouching, color correction, typography, and compositing. Learners will explore creative workflows for branding, social media, advertising, and digital art. By the end of the course, students will be proficient in Photoshop and capable of producing high-quality visual content for personal or professional use.",
  "image": "https://img-c.udemycdn.com/course/480x270/5346430_f677.jpg",
  "syllabus": [
    {
      "module": "Module 1: Getting Started with Photoshop",
      "topics": [
        "Workspace and interface overview",
        "Understanding raster vs vector graphics",
        "Working with layers and selections",
        "Basic photo corrections",
        "Saving and exporting files"
      ]
    },
    {
      "module": "Module 2: Image Editing & Retouching",
      "topics": [
        "Color correction and enhancement",
        "Using masks and adjustment layers",
        "Healing brush and clone stamp tools",
        "Removing backgrounds and objects",
        "Smart filters and layer styles"
      ]
    },
    {
      "module": "Module 3: Graphic Design & Typography",
      "topics": [
        "Creating banners and social media posts",
        "Working with text and fonts",
        "Designing logos and icons",
        "Shape tools and vector paths",
        "Blending modes and effects"
      ]
    },
    {
      "module": "Module 4: Creative Projects & Portfolio",
      "topics": [
        "Photo manipulation and compositing",
        "Digital painting basics",
        "Mockups and branding assets",
        "Preparing files for print and web",
        "Portfolio creation and presentation"
      ]
    }
  ],
  "tools": [
    "Adobe Photoshop",
    "Adobe Bridge",
    "Adobe Camera Raw",
    "Adobe Fonts",
    "Adobe Stock"
  ],
  "whatYouLearn": [
    "Navigate and customize Photoshop workspace",
    "Edit and retouch photos professionally",
    "Design graphics for web and print",
    "Use layers, masks, and smart objects",
    "Create compositions and digital artwork",
    "Apply effects, filters, and typography",
    "Build a portfolio with real-world projects"
  ],
  "whoCanEnroll": [
    "Graphic design students",
    "Photographers and photo editors",
    "Social media managers",
    "Marketing professionals",
    "Digital artists and illustrators",
    "Freelancers and content creators"
  ],
  "careerPaths": [
    "Graphic Designer",
    "Photo Editor",
    "Digital Artist",
    "Social Media Designer",
    "Brand Visualizer",
    "Creative Content Producer"
  ],
  "testimonials": [
    {
      "name": "Meera Joshi",
      "role": "Freelance Graphic Designer",
      "content": "Photoshop felt intimidating at first, but this course broke it down beautifully. I now design client logos and social media posts with confidence.",
      "rating": 5
    },
    {
      "name": "Ravi Kapoor",
      "role": "Photography Enthusiast",
      "content": "The retouching and color grading modules were exactly what I needed. My photos look professional now!",
      "rating": 4.5
    }
  ]
},
"adobephoto5": {
  "title": "Adobe Photoshop 5: Classic Image Editing Techniques",
  "description": "Explore the legacy features of Adobe Photoshop 5 and learn foundational image editing skills that shaped modern digital design.",
  "category": "Multimedia",
  "duration": "2.5 months",
  "level": "Beginner to Enthusiast",
  "students": "800+",
  "rating": 4.5,
  "price": "₹18,000",
  "whatIsCourse": "This course dives into Adobe Photoshop 5, the iconic 1998 version that introduced revolutionary features like editable text layers, magnetic lasso, and the history palette. Designed for enthusiasts and retro software lovers, this course teaches the fundamentals of image editing using the classic interface and tools. Learners will explore photo retouching, layer effects, color correction, and early compositing techniques. By the end of the course, students will understand the roots of modern Photoshop workflows and be able to create vintage-style graphics and layouts using Photoshop 5.",
  "image": "https://infinitegraphixads.com/wp-content/uploads/2020/04/unnamed.jpg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to Photoshop 5",
      "topics": [
        "Installing and navigating the classic interface",
        "Understanding bitmap graphics",
        "Working with layers and selections",
        "Using the magnetic lasso tool",
        "Saving and exporting in legacy formats"
      ]
    },
    {
      "module": "Module 2: Editing & Retouching",
      "topics": [
        "Basic photo corrections",
        "Using clone stamp and healing tools",
        "Color balance and hue/saturation",
        "Applying layer effects like drop shadows",
        "Creating vintage-style compositions"
      ]
    },
    {
      "module": "Module 3: Typography & Layout",
      "topics": [
        "Editable text layers",
        "Font management in legacy systems",
        "Designing posters and flyers",
        "Using guides and rulers",
        "Preparing files for print"
      ]
    },
    {
      "module": "Module 4: Creative Projects",
      "topics": [
        "Photo montage and collages",
        "Retro ad design",
        "Exporting for web (GIF, JPEG)",
        "Creating mockups with layer styles",
        "Final project: Vintage magazine cover"
      ]
    }
  ],
  "tools": [
    "Adobe Photoshop 5.0",
    "Adobe ImageReady 2.0",
    "Adobe Type Manager",
    "Legacy plug-ins and filters"
  ],
  "whatYouLearn": [
    "Navigate and use Photoshop 5’s classic interface",
    "Edit and retouch photos using foundational tools",
    "Apply vintage layer effects and styles",
    "Design layouts with editable text layers",
    "Create retro graphics and compositions",
    "Understand the evolution of digital design workflows"
  ],
  "whoCanEnroll": [
    "Design history enthusiasts",
    "Retro software collectors",
    "Graphic design students",
    "Photographers exploring legacy tools",
    "Educators teaching design evolution",
    "Creative hobbyists"
  ],
  "careerPaths": [
    "Graphic Design Historian",
    "Retro Content Creator",
    "Visual Archivist",
    "Digital Restoration Artist",
    "Design Educator",
    "Creative Freelancer"
  ],
  "testimonials": [
    {
      "name": "Ananya Rao",
      "role": "Design Educator",
      "content": "This course gave me a new appreciation for how far Photoshop has come. Teaching students the roots of design has never been more engaging.",
      "rating": 5
    },
    {
      "name": "Vikram Desai",
      "role": "Retro Graphics Enthusiast",
      "content": "I loved working with the old interface and tools. It felt like stepping into a time capsule of creativity.",
      "rating": 4.5
    }
  ]
},
"coreldraw": {
  "title": "CorelDRAW: Vector Illustration & Graphic Design",
  "description": "Master CorelDRAW to create professional-grade vector graphics, layouts, and branding assets for print and digital media.",
  "category": "Multimedia",
  "duration": "3 months",
  "level": "Beginner to Intermediate",
  "students": "1,000+",
  "rating": 4.6,
  "price": "₹22,000",
  "whatIsCourse": "The CorelDRAW course is designed for aspiring graphic designers, illustrators, and branding professionals who want to learn vector-based design. This course covers everything from basic drawing tools and shape manipulation to advanced layout design, typography, and logo creation. Students will gain hands-on experience with CorelDRAW Graphics Suite, learning how to design for print, packaging, signage, and digital platforms. By the end of the course, learners will be equipped to produce high-quality vector artwork and pursue careers in graphic design, advertising, or publishing.",
  "image": "https://t4.ftcdn.net/jpg/04/02/36/97/360_F_402369719_49TGMhNw8Z8iKiQIOTO8QLFWWt1iWdOR.jpg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to CorelDRAW",
      "topics": [
        "CorelDRAW interface and workspace",
        "Understanding vector graphics",
        "Basic drawing and shape tools",
        "Working with layers and objects",
        "Saving and exporting projects"
      ]
    },
    {
      "module": "Module 2: Design Fundamentals",
      "topics": [
        "Color theory and palettes",
        "Typography and text effects",
        "Using templates and styles",
        "Creating logos and icons",
        "Designing posters and flyers"
      ]
    },
    {
      "module": "Module 3: Advanced Techniques",
      "topics": [
        "Bezier curves and node editing",
        "PowerClip and transparency effects",
        "Layout design for print and packaging",
        "Working with bitmap images",
        "Preparing files for commercial printing"
      ]
    },
    {
      "module": "Module 4: Portfolio & Branding Projects",
      "topics": [
        "Brand identity design",
        "Mockups and client presentations",
        "Exporting for web and social media",
        "Final project: Complete brand kit",
        "Portfolio review and feedback"
      ]
    }
  ],
  "tools": [
    "CorelDRAW Graphics Suite",
    "Corel PHOTO-PAINT",
    "Corel Font Manager",
    "Corel PowerTRACE",
    "Corel CAPTURE"
  ],
  "whatYouLearn": [
    "Create vector illustrations and logos",
    "Design layouts for print and digital media",
    "Apply typography and color theory",
    "Use advanced drawing and editing tools",
    "Prepare files for professional output",
    "Build a portfolio with branding projects"
  ],
  "whoCanEnroll": [
    "Graphic design students",
    "Branding professionals",
    "Print and packaging designers",
    "Advertising creatives",
    "Freelancers and entrepreneurs",
    "Illustrators and visual artists"
  ],
  "careerPaths": [
    "Graphic Designer",
    "Brand Identity Specialist",
    "Packaging Designer",
    "Print Production Artist",
    "Creative Illustrator",
    "Advertising Designer"
  ],
  "testimonials": [
    {
      "name": "Neha Bansal",
      "role": "Brand Designer",
      "content": "CorelDRAW gave me the tools to design logos and packaging for my clients. The PowerClip feature was a revelation!",
      "rating": 5
    },
    {
      "name": "Aman Gupta",
      "role": "Freelance Illustrator",
      "content": "I loved how intuitive CorelDRAW felt. The course helped me polish my vector skills and land new projects.",
      "rating": 4.5
    }
  ]
},
"flash": {
  "title": "Flash: Interactive Animation & Web Media",
  "description": "Learn to create engaging animations, interactive content, and web applications using Adobe Flash and ActionScript.",
  "category": "Multimedia",
  "duration": "3 months",
  "level": "Beginner to Intermediate",
  "students": "900+",
  "rating": 4.5,
  "price": "₹20,000",
  "whatIsCourse": "This course explores Adobe Flash, the iconic multimedia platform that revolutionized web animation and interactive design. Students will learn how to create vector-based animations, interactive buttons, and dynamic web content using Flash’s timeline and scripting tools. The course includes hands-on practice with ActionScript, enabling learners to build interactive games, animated websites, and multimedia presentations. Though Flash is now discontinued, this course offers valuable insight into its legacy and teaches transferable skills applicable to modern animation tools like Adobe Animate.",
  "image": "https://static1.thegamerimages.com/wordpress/wp-content/uploads/2021/01/Flash-is-dead.jpg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to Adobe Flash",
      "topics": [
        "Flash interface and workspace",
        "Understanding vector animation",
        "Timeline and keyframes",
        "Drawing tools and layers",
        "Creating basic animations"
      ]
    },
    {
      "module": "Module 2: Interactive Elements",
      "topics": [
        "Creating buttons and movie clips",
        "Using symbols and instances",
        "Basic ActionScript programming",
        "Interactive navigation",
        "Publishing Flash content"
      ]
    },
    {
      "module": "Module 3: Advanced Animation Techniques",
      "topics": [
        "Motion and shape tweening",
        "Masking and layering effects",
        "Sound integration and syncing",
        "Building animated web banners",
        "Game development basics"
      ]
    },
    {
      "module": "Module 4: Legacy & Transition",
      "topics": [
        "Exporting to SWF and FLV formats",
        "Flash to HTML5 conversion",
        "Introduction to Adobe Animate",
        "Preserving Flash projects",
        "Final project: Interactive animation showcase"
      ]
    }
  ],
  "tools": [
    "Adobe Flash Professional",
    "ActionScript 2.0 / 3.0",
    "Adobe Animate",
    "Flash Player",
    "Adobe AIR"
  ],
  "whatYouLearn": [
    "Create vector-based animations",
    "Build interactive web content",
    "Use ActionScript for interactivity",
    "Design animated banners and games",
    "Publish projects for web and desktop",
    "Understand Flash’s legacy and evolution"
  ],
  "whoCanEnroll": [
    "Animation students",
    "Web designers",
    "Game developers",
    "Multimedia artists",
    "Educators and trainers",
    "Creative hobbyists"
  ],
  "careerPaths": [
    "Multimedia Designer",
    "Interactive Animator",
    "Web Game Developer",
    "E-learning Content Creator",
    "Digital Storyteller",
    "Creative Technologist"
  ],
  "testimonials": [
    {
      "name": "Ritika Sharma",
      "role": "Multimedia Artist",
      "content": "This course helped me understand the roots of interactive animation. The ActionScript module was surprisingly fun and useful.",
      "rating": 5
    },
    {
      "name": "Arjun Menon",
      "role": "Web Developer",
      "content": "Even though Flash is retired, the skills I learned here apply directly to modern tools like Animate and HTML5.",
      "rating": 4.5
    }
  ]
},


//others
"ecommerce": {
  "title": "E-Commerce: Online Business & Digital Retail",
  "description": "Learn how to build, manage, and grow a successful online business through modern e-commerce strategies and platforms.",
  "category": "others",
  "duration": "4 months",
  "level": "Beginner to Intermediate",
  "students": "2,000+",
  "rating": 4.7,
  "price": "₹30,000",
  "whatIsCourse": "The E-Commerce course is designed for entrepreneurs, marketers, and business professionals who want to launch or scale an online store. This course covers the fundamentals of digital commerce, including product sourcing, website setup, payment integration, marketing strategies, and customer service. Learners will explore various e-commerce models such as B2C, B2B, and dropshipping, while gaining hands-on experience with platforms like Shopify, WooCommerce, and Amazon Seller Central. By the end of the course, students will be equipped to run a profitable e-commerce business and adapt to the evolving digital marketplace.",
  "image": "https://media.istockphoto.com/id/1428709516/photo/shopping-online-woman-hand-online-shopping-on-laptop-computer-with-virtual-graphic-icon.jpg?s=612x612&w=0&k=20&c=ROAncmFL4lbSQdU4VOhyXu-43ngzfEqHE5ZZAw5FtYk=",
  "syllabus": [
    {
      "module": "Module 1: Introduction to E-Commerce",
      "topics": [
        "What is e-commerce?",
        "Types of e-commerce models (B2C, B2B, C2C)",
        "Market trends and opportunities",
        "Legal and regulatory considerations",
        "Choosing the right platform"
      ]
    },
    {
      "module": "Module 2: Store Setup & Product Management",
      "topics": [
        "Setting up an online store (Shopify, WooCommerce)",
        "Product sourcing and inventory management",
        "Pricing strategies and catalog design",
        "Payment gateways and checkout optimization",
        "Shipping and logistics"
      ]
    },
    {
      "module": "Module 3: Digital Marketing & Sales",
      "topics": [
        "SEO and content marketing",
        "Social media and influencer campaigns",
        "Email marketing and automation",
        "Paid ads (Google, Meta, Amazon)",
        "Conversion rate optimization"
      ]
    },
    {
      "module": "Module 4: Growth & Customer Experience",
      "topics": [
        "Customer service and retention",
        "Analytics and performance tracking",
        "Scaling with marketplaces (Amazon, Flipkart)",
        "Mobile commerce and app integration",
        "Final project: Launch a live store"
      ]
    }
  ],
  "tools": [
    "Shopify",
    "WooCommerce",
    "Amazon Seller Central",
    "Google Analytics",
    "Meta Ads Manager",
    "Canva"
  ],
  "whatYouLearn": [
    "Understand e-commerce business models",
    "Build and manage an online store",
    "Source products and manage inventory",
    "Run digital marketing campaigns",
    "Optimize user experience and conversions",
    "Analyze performance and scale operations",
    "Launch a real-world e-commerce business"
  ],
  "whoCanEnroll": [
    "Aspiring entrepreneurs",
    "Small business owners",
    "Marketing professionals",
    "Freelancers and consultants",
    "Students in business and commerce",
    "Retailers transitioning to online"
  ],
  "careerPaths": [
    "E-Commerce Manager",
    "Digital Marketing Specialist",
    "Online Store Owner",
    "Product Manager",
    "Dropshipping Entrepreneur",
    "Marketplace Consultant"
  ],
  "testimonials": [
    {
      "name": "Priya Nair",
      "role": "Online Boutique Owner",
      "content": "This course helped me launch my Shopify store and grow my brand through Instagram marketing. Highly practical and easy to follow.",
      "rating": 5
    },
    {
      "name": "Rohit Malhotra",
      "role": "Digital Marketing Executive",
      "content": "I gained a solid understanding of e-commerce funnels and ad strategies. The modules on analytics and scaling were especially useful.",
      "rating": 4.5
    }
  ]
},
"tally": {
  title: "Tally with GST & ERP",
  description:
    "Master accounting, taxation, payroll, and business management using Tally ERP software",
  category: "Others",
  duration: "3 months",
  level: "Beginner to Intermediate",
  students: "500+",
  rating: 4.7,
  price: "₹15,000",
  whatIsCourse:
    "The Tally course provides in-depth training on computerized accounting, GST, payroll management, and inventory control using Tally ERP software. Learners will understand how to maintain books of accounts, generate reports, handle taxation, and manage business transactions efficiently. The course covers real-world applications of Tally in small to large enterprises, making it ideal for aspiring accountants, finance professionals, and entrepreneurs. By the end, students will be job-ready for roles in accounting, taxation, and ERP management.",
  image:
    "https://anjalicomputereducation.com/assets/anjali/course/tally-erp9.jpg",
  syllabus: [
    {
      module: "Module 1: Fundamentals of Accounting & Tally",
      topics: [
        "Basics of Accounting",
        "Introduction to Tally ERP",
        "Company creation and setup",
        "Ledger and group creation",
        "Voucher entry and recording transactions",
      ],
    },
    {
      module: "Module 2: Inventory & GST",
      topics: [
        "Inventory management",
        "Stock groups, categories, and items",
        "GST setup and configuration",
        "Recording GST transactions",
        "Generating GST reports and returns",
      ],
    },
    {
      module: "Module 3: Payroll & Taxation",
      topics: [
        "Payroll setup and employee management",
        "Salary processing and payslips",
        "TDS setup and compliance",
        "Recording tax-related entries",
        "PF, ESI, and other statutory features",
      ],
    },
    {
      module: "Module 4: Advanced Tally & Reporting",
      topics: [
        "Bank reconciliation",
        "Budgeting and forecasting",
        "MIS reports",
        "Data backup and restoration",
        "Tally security and user management",
      ],
    },
  ],
  tools: ["Tally ERP 9", "TallyPrime", "MS Excel"],
  whatYouLearn: [
    "Understand accounting principles",
    "Work with Tally ERP and TallyPrime",
    "Handle GST, TDS, and other taxation",
    "Manage payroll and employee records",
    "Perform inventory and stock management",
    "Generate business reports and MIS analysis",
    "Maintain secure financial data",
  ],
  whoCanEnroll: [
    "Accounting students",
    "Commerce graduates",
    "Finance professionals",
    "Small business owners",
    "Entrepreneurs",
    "Anyone aspiring for an accounting career",
  ],
  careerPaths: [
    "Accountant",
    "Tally Operator",
    "GST Practitioner",
    "Payroll Executive",
    "Finance Assistant",
    "ERP Executive",
  ],
  testimonials: [
    {
      name: "Ankit Sharma",
      role: "Accounts Executive at Infosys",
      content:
        "This course made me job-ready. The GST and payroll sections were very useful for my career.",
      rating: 5,
    },
    {
      name: "Megha Patel",
      role: "Freelance Accountant",
      content:
        "Very practical training with real-life examples. Helped me handle client accounts with confidence.",
      rating: 4,
    },
  ],
},
"auto": {
  title: "AutoCAD Design & Drafting",
  description:
    "Learn 2D drafting and 3D modeling using AutoCAD for engineering, architecture, and design projects",
  category: "Others",
  duration: "4 months",
  level: "Beginner to Advanced",
  students: "450+",
  rating: 4.6,
  price: "₹20,000",
  whatIsCourse:
    "The AutoCAD course provides comprehensive training on creating, modifying, and optimizing 2D drawings and 3D models using Autodesk AutoCAD software. Students will learn essential drafting tools, dimensioning, annotations, layouts, and 3D visualization techniques. This course is tailored for engineers, architects, designers, and drafters who want to create accurate technical drawings and models. With real-world projects, learners will gain the practical skills required to work in industries such as construction, manufacturing, interior design, and architecture.",
  image:
    "https://wallpapers.com/images/hd/auto-c-a-d-software-logo-over-blueprints-j1fvx817r2sc2s6v-2.jpg",
  syllabus: [
    {
      module: "Module 1: Introduction to AutoCAD",
      topics: [
        "AutoCAD interface and navigation",
        "Basic drawing tools",
        "Coordinate systems",
        "Editing and modifying objects",
        "Saving and managing files",
      ],
    },
    {
      module: "Module 2: 2D Drafting & Annotations",
      topics: [
        "Drawing precision with object snaps and tracking",
        "Dimensioning and annotations",
        "Layers and line types",
        "Blocks and attributes",
        "Layouts and plotting",
      ],
    },
    {
      module: "Module 3: 3D Modeling",
      topics: [
        "Introduction to 3D workspace",
        "3D primitives and solids",
        "Extrude, revolve, sweep, loft",
        "3D modifications and editing",
        "Rendering and visualization",
      ],
    },
    {
      module: "Module 4: Advanced AutoCAD Applications",
      topics: [
        "Dynamic blocks and parametric design",
        "External references (Xrefs)",
        "Customizing tool palettes and templates",
        "Importing/exporting drawings",
        "Industry-based projects and case studies",
      ],
    },
  ],
  tools: ["AutoCAD", "DWG TrueView", "Autodesk Viewer"],
  whatYouLearn: [
    "Create and modify 2D technical drawings",
    "Work with dimensions, annotations, and layers",
    "Develop 3D models for engineering and architecture",
    "Render and visualize 3D designs",
    "Customize AutoCAD tools and workflows",
    "Generate accurate project documentation",
    "Apply AutoCAD skills to real-world projects",
  ],
  whoCanEnroll: [
    "Civil engineers",
    "Mechanical engineers",
    "Architects",
    "Interior designers",
    "Draftsmen",
    "Students in design and engineering fields",
  ],
  careerPaths: [
    "AutoCAD Designer",
    "Draftsman",
    "Civil CAD Engineer",
    "Mechanical CAD Engineer",
    "Architectural Designer",
    "Interior Design Draftsperson",
  ],
  testimonials: [
    {
      name: "Rahul Verma",
      role: "Civil CAD Engineer at L&T",
      content:
        "The course gave me hands-on skills in both 2D drafting and 3D modeling. Very practical and industry-relevant.",
      rating: 5,
    },
    {
      name: "Sneha Kapoor",
      role: "Interior Designer",
      content:
        "Great training for beginners. I especially liked the projects that matched real-world design tasks.",
      rating: 4,
    },
  ],
},
"accounting": {
  title: "Accounting & Financial Management",
  description:
    "Learn the fundamentals of accounting, bookkeeping, and financial management for business and personal growth",
  category: "Others",
  duration: "4 months",
  level: "Beginner to Intermediate",
  students: "600+",
  rating: 4.7,
  price: "₹18,000",
  whatIsCourse:
    "The Accounting course provides in-depth knowledge of financial accounting, bookkeeping, taxation, and management accounting. Students learn how to record, analyze, and report financial transactions, prepare financial statements, and understand the principles of auditing and taxation. The course also covers computerized accounting systems, cost accounting, and budgeting techniques. With practical exercises and real-life case studies, learners gain the skills to manage finances for businesses, organizations, and individuals, preparing them for roles in finance, accounting, and business management.",
  image:
    "https://www.shutterstock.com/image-photo/finance-banking-investment-asset-allocation-600nw-2467052941.jpg",
  syllabus: [
    {
      module: "Module 1: Fundamentals of Accounting",
      topics: [
        "Introduction to accounting concepts",
        "Double-entry system of bookkeeping",
        "Journal, ledger, and trial balance",
        "Subsidiary books",
        "Rectification of errors",
      ],
    },
    {
      module: "Module 2: Financial Accounting",
      topics: [
        "Preparation of final accounts",
        "Depreciation accounting",
        "Bank reconciliation statement",
        "Accounting for bills of exchange",
        "Partnership accounts",
      ],
    },
    {
      module: "Module 3: Management & Cost Accounting",
      topics: [
        "Introduction to cost accounting",
        "Budgeting and budgetary control",
        "Standard costing and variance analysis",
        "Marginal costing and break-even analysis",
        "Decision-making techniques",
      ],
    },
    {
      module: "Module 4: Taxation & Auditing",
      topics: [
        "Basics of direct and indirect taxes",
        "GST fundamentals",
        "Income tax computation",
        "Internal and statutory auditing",
        "Ethics in accounting",
      ],
    },
    {
      module: "Module 5: Computerized Accounting",
      topics: [
        "Introduction to Tally ERP/QuickBooks",
        "Voucher entry and inventory management",
        "Payroll processing",
        "Generating financial reports",
        "Data security in accounting software",
      ],
    },
  ],
  tools: ["Tally ERP", "QuickBooks", "MS Excel", "Zoho Books"],
  whatYouLearn: [
    "Understand accounting principles and standards",
    "Maintain and manage financial records",
    "Prepare financial statements and reports",
    "Analyze costs and budgets for decision-making",
    "Work with taxation and auditing fundamentals",
    "Use computerized accounting software",
    "Apply accounting skills in real-world business scenarios",
  ],
  whoCanEnroll: [
    "Commerce and finance students",
    "Business owners and entrepreneurs",
    "Aspiring accountants",
    "Bookkeepers",
    "Finance professionals",
    "MBA and management students",
  ],
  careerPaths: [
    "Accountant",
    "Financial Analyst",
    "Tax Consultant",
    "Auditor",
    "Cost Accountant",
    "Finance Manager",
    "Business Analyst",
  ],
  testimonials: [
    {
      name: "Ankit Sharma",
      role: "Junior Accountant at Deloitte",
      content:
        "This course gave me a strong foundation in accounting principles and practical skills with Tally and Excel.",
      rating: 5,
    },
    {
      name: "Meera Nair",
      role: "Entrepreneur",
      content:
        "Very helpful for managing my business accounts. The taxation and GST section was extremely useful.",
      rating: 4,
    },
  ],
},
"msexcel": {
  "title": "Microsoft Excel: Data Analysis & Spreadsheet Mastery",
  "description": "Learn to organize, analyze, and visualize data using Microsoft Excel—from formulas and charts to pivot tables and automation.",
  "category": "Others",
  "duration": "3 months",
  "level": "Beginner to Intermediate",
  "students": "2,500+",
  "rating": 4.9,
  "price": "₹26,000",
  "whatIsCourse": "This course is designed for professionals, students, and entrepreneurs who want to master Microsoft Excel for data management, reporting, and decision-making. Covering everything from basic spreadsheet operations to advanced functions, charts, and automation with VBA, learners will gain hands-on experience with real-world datasets. By the end of the course, students will be able to confidently use Excel for financial modeling, project tracking, dashboards, and business analysis.",
  "image": "https://africanabi.com/wp-content/uploads/2021/05/MsExcel.png",
  "syllabus": [
    {
      "module": "Module 1: Excel Fundamentals",
      "topics": [
        "Excel interface and navigation",
        "Creating and formatting spreadsheets",
        "Basic formulas and functions",
        "Cell referencing and ranges",
        "Saving and sharing workbooks"
      ]
    },
    {
      "module": "Module 2: Data Management & Analysis",
      "topics": [
        "Sorting and filtering data",
        "Conditional formatting",
        "Using logical and lookup functions",
        "Data validation and protection",
        "Working with large datasets"
      ]
    },
    {
      "module": "Module 3: Visualization & Reporting",
      "topics": [
        "Creating charts and graphs",
        "Pivot tables and slicers",
        "Dashboards and summary reports",
        "Using templates and themes",
        "Exporting reports to PDF and print"
      ]
    },
    {
      "module": "Module 4: Automation & Advanced Tools",
      "topics": [
        "Introduction to Excel VBA",
        "Recording and editing macros",
        "Automating repetitive tasks",
        "Integrating Excel with other Office apps",
        "Final project: Business dashboard"
      ]
    }
  ],
  "tools": [
    "Microsoft Excel (365 or standalone)",
    "Power Query",
    "Excel VBA",
    "Pivot Tables",
    "Data Analysis Toolpak"
  ],
  "whatYouLearn": [
    "Create and format professional spreadsheets",
    "Use formulas and functions for calculations",
    "Analyze data with filters, charts, and pivot tables",
    "Build dashboards and reports for decision-making",
    "Automate tasks using macros and VBA",
    "Apply Excel in finance, marketing, and operations"
  ],
  "whoCanEnroll": [
    "Business professionals",
    "Students and researchers",
    "Entrepreneurs and freelancers",
    "Finance and HR teams",
    "Project managers",
    "Anyone seeking data literacy"
  ],
  "careerPaths": [
    "Data Analyst",
    "Financial Planner",
    "Operations Manager",
    "Business Intelligence Associate",
    "Excel Automation Specialist",
    "Administrative Executive"
  ],
  "testimonials": [
    {
      "name": "Anjali Mehta",
      "role": "Finance Analyst",
      "content": "This course helped me build dynamic reports and automate monthly tasks. Excel is now my go-to tool for analysis.",
      "rating": 5
    },
    {
      "name": "Ramesh Kumar",
      "role": "Small Business Owner",
      "content": "I used to struggle with inventory and billing. Now I manage everything in Excel with ease. Highly practical course.",
      "rating": 4.5
    }
  ]
},
"internet": {
  "title": "Internet: Foundations, Technologies & Digital Literacy",
  "description": "Understand the core principles of the Internet, its infrastructure, protocols, and how it powers modern communication, commerce, and innovation.",
  "category": "Others",
  "duration": "2.5 months",
  "level": "Beginner",
  "students": "3,000+",
  "rating": 4.7,
  "price": "₹21,000",
  "whatIsCourse": "This course introduces learners to the Internet—its origins, architecture, and impact on society. Students will explore how the Internet works, including protocols like TCP/IP, DNS, and HTTP, and how data travels across networks. The course covers web browsing, email, cloud services, cybersecurity basics, and the role of the Internet in global connectivity. By the end of the course, learners will be digitally literate, able to navigate online platforms safely, and understand the technologies that make the Internet function.",
  "image": "https://informationage-production.s3.amazonaws.com/uploads/2022/10/AdobeStock_116472569-2-1568x1030.jpeg",
  "syllabus": [
    {
      "module": "Module 1: Introduction to the Internet",
      "topics": [
        "History and evolution of the Internet",
        "What is the Internet vs. the Web",
        "Internet protocols (TCP/IP, HTTP, FTP)",
        "Understanding IP addresses and DNS",
        "How data travels across networks"
      ]
    },
    {
      "module": "Module 2: Internet Applications & Services",
      "topics": [
        "Web browsers and search engines",
        "Email and cloud services",
        "Streaming, social media, and e-commerce",
        "Online collaboration tools",
        "Mobile Internet and apps"
      ]
    },
    {
      "module": "Module 3: Safety, Ethics & Digital Citizenship",
      "topics": [
        "Cybersecurity basics",
        "Online privacy and data protection",
        "Digital etiquette and responsible use",
        "Recognizing misinformation and scams",
        "Safe browsing and parental controls"
      ]
    },
    {
      "module": "Module 4: Future of the Internet",
      "topics": [
        "Internet of Things (IoT)",
        "5G and next-gen connectivity",
        "Decentralized web and blockchain",
        "AI and automation in online services",
        "Final project: Internet impact presentation"
      ]
    }
  ],
  "tools": [
    "Web browsers (Chrome, Firefox, Edge)",
    "Email platforms (Gmail, Outlook)",
    "Cloud storage (Google Drive, OneDrive)",
    "Network simulators (optional)",
    "Cybersecurity awareness tools"
  ],
  "whatYouLearn": [
    "Understand how the Internet works",
    "Use web tools and services effectively",
    "Navigate online platforms safely",
    "Recognize and avoid digital threats",
    "Explore emerging Internet technologies",
    "Become a responsible digital citizen"
  ],
  "whoCanEnroll": [
    "Students and educators",
    "Working professionals",
    "Senior citizens learning digital tools",
    "Parents and guardians",
    "Aspiring tech enthusiasts",
    "Anyone seeking digital literacy"
  ],
  "careerPaths": [
    "IT Support Specialist",
    "Digital Literacy Trainer",
    "Cybersecurity Assistant",
    "Web Research Analyst",
    "Online Content Moderator",
    "Tech Educator"
  ],
  "testimonials": [
    {
      "name": "Lakshmi Narayan",
      "role": "School Teacher",
      "content": "This course helped me teach students how to use the Internet safely and effectively. The modules on digital citizenship were excellent.",
      "rating": 5
    },
    {
      "name": "Rajesh Iyer",
      "role": "Freelancer",
      "content": "I finally understood how the Internet works behind the scenes. It gave me confidence to explore online tools and protect my data.",
      "rating": 4.5
    }
  ]
}

};
